<template>
  <core-view class="flex-column" fill-height>
    <div v-if="!loading" class="center">
      <v-form ref="form" v-model="formValido" lazy-validation>
        <!-- Data e Hora -->
        <div class="linha mb-4">
          <core-date-time-picker-field
            hide-details
            form
            v-model="formulario.dataHora"
            :label="['Data', 'Hora']"
            :rules="rules.dataHora"
          />
        </div>

        <!-- Frota -->
        <div class="linha">
          <btn-auto-complete
            label="Frota (Veículo/Maquinário)"
            :dados="autocomplete.frota"
            v-model="formulario.frota"
            itemLabel="veidescricao"
            item-value="id"
            :rules="rules.frota"
            clearable
            :filter="$_filtroFrota"
            @change="$_onFrotaChange"
            @click:append="$_abrirTelaSelecao('frota')"
          />
        </div>

        <!-- Operador -->
        <div class="linha">
          <btn-auto-complete
            label="Operador"
            :dados="autocomplete.operador"
            v-model="formulario.operador"
            itemLabel="pesnome"
            item-value="id"
            :rules="rules.operador"
            clearable
            :filter="$_filtroOperador"
            @click:append="$_abrirTelaSelecao('operador')"
          />
        </div>

        <!-- Odômetro de KM ou HH -->
        <div class="linha odometro-wrapper mb-4">
          <v-text-field
            outlined
            :dense="!$vuetify.breakpoint.mobile"
            background-color="white"
            :label="labelOdometro"
            type="number"
            min="0"
            step="any"
            maxlength="9"
            oninput="if (this.value.length > 9) this.value = this.value.slice(0, 9);"
            v-model="formulario.odometro"
            :rules="rules.odometro"
            hide-details="auto"
            class="campo-odometro"
            @input="$_limitarOdometro"
          />
          <v-btn-toggle
            v-model="formulario.tipoOdometro"
            mandatory
            color="primary"
            class="toggle-odometro ml-2"
            :class="{ 'toggle-odometro-bloqueado': veiculoSelecionado }"
            :height="alturaCampos"
            :title="veiculoSelecionado ? 'Tipo de odômetro fixo conforme veículo selecionado' : ''"
          >
            <v-btn
              value="KM"
              :height="alturaCampos"
              class="btn-toggle-item"
              :disabled="veiculoSelecionado"
            >
              KM
            </v-btn>
            <v-btn
              value="HH"
              :height="alturaCampos"
              class="btn-toggle-item"
              :disabled="veiculoSelecionado"
            >
              HH
            </v-btn>
          </v-btn-toggle>
        </div>

        <!-- Evento -->
        <div class="linha">
          <btn-auto-complete
            label="Evento"
            :dados="autocomplete.evento"
            v-model="formulario.evento"
            itemLabel="evvdescricao"
            item-value="id"
            :rules="rules.evento"
            clearable
            :filter="$_filtroEvento"
            @click:append="$_abrirTelaSelecao('evento')"
          />
        </div>

        <!-- Executor e Forma da Manutenção (Interna / Externa) -->
        <div class="linha executor-wrapper mb-4">
          <btn-auto-complete
            label="Executor"
            :dados="autocomplete.executor"
            v-model="formulario.executor"
            itemLabel="pesnome"
            item-value="id"
            :rules="rules.executor"
            clearable
            :filter="$_filtroOperador"
            class="campo-executor"
            @click:append="$_abrirTelaSelecao('executor')"
          />
          <v-btn-toggle
            v-model="formulario.tipoManutencao"
            mandatory
            color="primary"
            class="toggle-tipo-manutencao ml-2"
            :height="alturaCampos"
          >
            <v-btn value="I" :height="alturaCampos" class="btn-toggle-item btn-toggle-manutencao">
              Interna
            </v-btn>
            <v-btn value="E" :height="alturaCampos" class="btn-toggle-item btn-toggle-manutencao">
              Externa
            </v-btn>
          </v-btn-toggle>
        </div>

        <!-- Local (Propriedade) -->
        <div class="linha">
          <btn-auto-complete
            label="Local (Propriedade)"
            :dados="autocomplete.propriedade"
            v-model="formulario.propriedade"
            itemLabel="pronome"
            item-value="id"
            :rules="rules.propriedade"
            clearable
            :filter="$_filtroPropriedade"
            @click:append="$_abrirTelaSelecao('propriedade')"
          />
        </div>

        <!-- Atividade -->
        <div class="linha">
          <btn-auto-complete
            label="Atividade"
            :dados="autocomplete.atividade"
            v-model="formulario.atividade"
            itemLabel="veadescricao"
            item-value="id"
            :rules="rules.atividade"
            clearable
            :filter="$_filtroAtividade"
            @click:append="$_abrirTelaSelecao('atividade')"
          />
        </div>

        <!-- Garantia (Data) -->
        <div class="linha mb-2">
          <v-menu
            v-model="menuGarantia"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ attrs }">
              <v-text-field
                ref="campoGarantia"
                outlined
                dense
                background-color="white"
                v-model="garantiaDigitada"
                v-mask="'##/##/####'"
                label="Garantia (Data limite)"
                append-icon="mdi-calendar"
                clearable
                inputmode="numeric"
                @click:clear="$_limparGarantia"
                @click:append="menuGarantia = !menuGarantia"
                @input="$_onInputGarantia"
                @blur="$_onBlurGarantia"
                v-bind="attrs"
                hide-details="auto"
                :rules="rules.garantia"
                class="mb-3"
                placeholder="DD/MM/AAAA"
              />
            </template>
            <v-date-picker
              v-model="formulario.garantia"
              no-title
              scrollable
              locale="pt-br"
              :min="minDataGarantia"
              @input="menuGarantia = false"
            />
          </v-menu>
        </div>

        <!-- Observação -->
        <div class="linha">
          <v-textarea
          outlined
          dense
          background-color="white"
          label="Observação"
          rows="3"
          counter="300"
          maxlength="300"
          v-model="formulario.observacao"
          hide-details="auto"
          class="mb-3"
          placeholder="Descreva detalhes adicionais sobre a manutenção..."
          />
        </div>

        <!-- Botões de Ação -->
        <div class="divinferior">
          <v-btn
            :height="alturaCampos"
            color="grey darken-1"
            class="botaoinferior botaocancelar"
            @click="$_cancelar"
          >
            <v-icon left>{{ cadastroSalvo ? 'mdi-arrow-left' : 'mdi-close' }}</v-icon>
            {{ cadastroSalvo ? 'Voltar' : 'Cancelar' }}
          </v-btn>

          <v-btn
            :height="alturaCampos"
            color="green"
            class="botaoinferior botaosalvar"
            :loading="salvando"
            @click="$_salvaDados"
          >
            <v-icon left>mdi-check</v-icon>
            {{ cadastroSalvo ? 'Salvar' : 'Salvar' }}
          </v-btn>
        </div>

        <v-divider class="mb-2 divisor-tela-toda black"></v-divider>

        <!-- Itens / Peças Utilizadas -->
        <div class="secao-itens mb-3">
          <div class="linha mb-2 d-flex">
            <v-btn
              outlined
              color="green darken-1"
              class="botao-add-item flex-grow-1 mr-2"
              :height="alturaCampos"
              :disabled="!cadastroSalvo"
              @click="$_abrirDialogItem"
            >
              <v-icon left>mdi-plus</v-icon>
              Adicionar Item
            </v-btn>
            <!-- <v-btn
              outlined
              color="green darken-1"
              class="botao-add-item px-3"
              height="44"
              title="Abrir tela para selecionar itens"
              @click="$_abrirTelaSelecaoProduto"
            >
              <v-icon left>mdi-format-list-bulleted</v-icon>
              Selecionar Peça
            </v-btn> -->
          </div>

          <div v-if="!cadastroSalvo" class="text-caption grey--text text--darken-1 mb-2 px-1">
            <v-icon x-small color="grey darken-1" class="mr-1">mdi-information-outline</v-icon>
            Salve o cadastro acima para liberar a inclusão de itens/peças.
          </div>

          <!-- Lista de Itens Adicionados -->
          <div v-if="formulario.itens.length > 0" class="lista-itens mb-2">

            <div
              v-if="totalItensValor > 0"
              class="total-itens-linha d-flex justify-space-between align-center px-3 py-2 text-caption font-weight-bold mt-2"
            >
              <span class="">Total dos Itens:</span>
              <span class="font-weight-bold">
                {{ $_formataMoeda(totalItensValor) }}
              </span>
            </div>

            <simplebar
              class="itens-simplebar-scroll"
              :autoHide="false"
            >
              <div
                v-for="(item, index) in formulario.itens"
                :key="index"
                class="item-card mb-2"
              >
                <div class="item-card-inner">
                  <div class="item-info-col">
                    <span class="item-numero font-weight-bold">
                      #{{ index + 1 }}
                    </span>
                    <div class="item-textos">
                      <div class="d-flex align-center flex-wrap">
                        <span class="item-descricao font-weight-medium">
                          {{ $_obterTextoItem(item) }}
                        </span>
                        <v-chip
                          x-small
                          class="ml-2 font-weight-bold"
                        >
                          {{ (item.tipo === 'M' || item.tipo === 'M.O.') ? 'M.O.' : 'Peça' }}
                        </v-chip>
                      </div>
                      <div class="item-detalhe grey--text text--darken-1 text-caption">
                        Qtd: {{ item.quantidade }} {{ item.unidade || 'UN' }}
                        <span v-if="item.valorUnitario">
                          • {{ $_formataMoeda(item.valorUnitario) }}/un
                        </span>
                        <span v-if="item.valorTotal" class="font-weight-bold ml-1">
                          ({{ $_formataMoeda(item.valorTotal) }})
                        </span>
                      </div>
                      <div
                        v-if="item.observacao"
                        class="item-observacao grey--text text--darken-2 text-caption mt-1"
                      >
                        <span class="font-weight-medium">Obs:</span> {{ item.observacao }}
                      </div>
                    </div>
                  </div>

                  <div class="item-acoes">
                    <v-btn
                      icon
                      small
                      color="primary"
                      class="mr-1"
                      title="Editar item"
                      @click="$_editarItem(index)"
                    >
                      <v-icon small>mdi-pencil-outline</v-icon>
                    </v-btn>
                    <!-- <v-btn
                      v-if="!item.imviditemmovimentacaoveiculo"
                      icon
                      small
                      color="red darken-1"
                      title="Remover item"
                      @click="$_removerItem(index)"
                    >
                      <v-icon small color="red lighten-1">mdi-delete-outline</v-icon>
                    </v-btn> -->
                  </div>
                </div>
              </div>
            </simplebar>

            <!-- Totalizador se houver valores nos itens -->

          </div>
        </div>
      </v-form>
    </div>

    <!-- Indicador de Carregamento -->
    <div v-else class="text-center my-10">
      <v-progress-circular indeterminate color="green" size="48"></v-progress-circular>
      <p class="mt-3 text-caption grey--text">Carregando formulário...</p>
    </div>

    <!-- Dialog Adicionar / Editar Item -->
    <v-dialog v-model="dialogItem" max-width="480px" persistent>
      <v-card rounded="lg">
        <v-card-title class="card-dialog-header py-3 px-4">
          <span class="text-subtitle-1 font-weight-bold">
            {{ itemEditandoIndex !== null ? 'Editar Item' : 'Adicionar Item' }}
          </span>
          <v-btn icon small @click="$_fecharDialogItem">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-4">
          <v-form ref="formItem" v-model="formItemValido" lazy-validation>
            <!-- Tipo do Item: Peça ou M.O. -->
            <div class="linha mb-3">
              <div class="text-caption font-weight-medium grey--text text--darken-2 mb-1">
                Tipo do Item *
              </div>
              <v-btn-toggle
                v-model="novoItem.tipo"
                mandatory
                color="primary"
                class="toggle-tipo-item d-flex"
                :height="alturaCampos"
              >
                <v-btn value="P" :height="alturaCampos" class="flex-grow-1 btn-toggle-tipo">
                  <v-icon left small>mdi-cog</v-icon>
                  Peça
                </v-btn>
                <v-btn value="M" :height="alturaCampos" class="flex-grow-1 btn-toggle-tipo">
                  <v-icon left small>mdi-wrench</v-icon>
                  M.O.
                </v-btn>
              </v-btn-toggle>
            </div>

            <!-- Item / Peça com btn-auto-complete -->
            <div class="linha mb-1">
              <btn-auto-complete
                :label="(novoItem.tipo === 'M' || novoItem.tipo === 'M.O.') ? 'Serviço / Mão de Obra *' : 'Item / Peça *'"
                :dados="autocomplete.produto"
                v-model="novoItem.produto"
                itemLabel="prodescricao"
                item-value="id"
                :filter="$_filtroProduto"
                :rules="rulesItem.produto"
                @change="$_onProdutoChange"
                @click:append="$_abrirTelaSelecaoProduto"
              />
            </div>

            <!-- Botão para abrir tela de seleção dos itens -->
            <!-- <div class="mb-4">
              <v-btn
                outlined
                small
                color="green darken-1"
                class="text-none font-weight-medium"
                block
                height="38"
                @click="$_abrirTelaSelecaoProduto"
              >
                <v-icon left small>mdi-format-list-bulleted</v-icon>
                Selecionar Peça na Lista
              </v-btn>
            </div> -->

            <!-- Quantidade e Unidade lado a lado -->
            <div class="d-flex mb-3">
              <v-text-field
                outlined
                dense
                background-color="white"
                label="Quantidade *"
                type="number"
                min="0.01"
                step="any"
                v-model.number="novoItem.quantidade"
                :rules="rulesItem.quantidade"
                hide-details="auto"
                class="mr-2"
              />

              <v-text-field
                outlined
                dense
                background-color="white"
                label="Unidade"
                v-model="novoItem.unidade"
                hide-details="auto"
                style="max-width: 110px;"
                placeholder="UN, L..."
              />
            </div>

            <!-- Valor Unitário (opcional) -->
            <div class="mb-2">
              <v-text-field
                outlined
                dense
                background-color="white"
                label="Valor Unitário (R$) - Opcional"
                type="number"
                min="0"
                step="0.01"
                v-model.number="novoItem.valorUnitario"
                hide-details="auto"
                placeholder="0,00"
              />
            </div>

            <!-- Observação do Item (opcional) -->
            <div class="mb-2">
              <v-textarea
                outlined
                dense
                background-color="white"
                label="Observação"
                rows="2"
                counter="500"
                maxlength="500"
                v-model="novoItem.observacao"
                hide-details="auto"
                placeholder="Observação sobre o item..."
              />
            </div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-3 d-flex justify-end align-center">
          <v-btn
            v-if="itemEditandoIndex !== null && (!novoItem || !novoItem.imviditemmovimentacaoveiculo)"
            text
            small
            color="red darken-1"
            class="mr-auto text-none font-weight-bold"
            title="Remover item"
            @click="$_removerItem(itemEditandoIndex)"
          >
            <v-icon left small color="red darken-1">mdi-delete-outline</v-icon>
            Excluir
          </v-btn>
          <v-btn
            text
            color="grey darken-1"
            class="mr-2 text-none"
            @click="$_fecharDialogItem"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green"
            dark
            class="px-4 text-none font-weight-bold"
            @click="$_confirmarItem"
          >
            <v-icon left small>mdi-check</v-icon>
            {{ itemEditandoIndex !== null ? 'Salvar' : 'Adicionar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Confirmar Saída -->
    <v-dialog v-model="dialogConfirmarSair" max-width="420" persistent>
      <v-card rounded="lg">
        <v-card-title class="py-3 px-4 primary d-flex align-center">
          <v-icon color="white" class="mr-2">mdi-alert-outline</v-icon>
          <span class="text-subtitle-1 font-weight-bold white--text">
            Confirmar Saída
          </span>
        </v-card-title>

        <v-card-text class="pt-4 pb-2 text-body-1 grey--text text--darken-3">
          Deseja realmente sair? As alterações não salvas serão descartadas.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-3 d-flex justify-end">
          <v-btn
            text
            color="grey darken-1"
            class="text-none font-weight-medium mr-2"
            @click="dialogConfirmarSair = false"
          >
            Não
          </v-btn>
          <v-btn
            color="primary darken-1"
            dark
            depressed
            class="text-none font-weight-bold px-4"
            @click="$_confirmarSair"
          >
            Sim, sair
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </core-view>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import simplebar from 'simplebar-vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'simplebar-vue/dist/simplebar.min.css';
import CoreView from '@/components/core/view/Index.vue';
import CoreDateTimePickerField from '@/components/core/variant/date-time-picker-field variant/Index.vue';
import BtnAutoComplete from '@/components/core/btn-auto-complete/Index.vue';
import moment from 'moment-timezone';
import geraData, { geraDataNuvem } from '@/utils/geradata';
import errorHandler from '@/utils/error-handler';
import db from '@/plugins/dexie';
import {
  ROUTE_MANUTENCAO_FROTA,
  ROUTE_MANUTENCAO_SELECAO,
  ROUTE_FROTA,
  ROUTE_OPERADOR,
  ROUTE_PROPRIEDADE,
  ROUTE_ATIVIDADE,
} from '@/constants/ROUTES';
import { MANUTENCAO_STORAGE, ROTA_STORAGE } from '@/constants/STORAGE';

export default {
  name: 'ViewManutencaoCadastro',

  components: {
    CoreView,
    CoreDateTimePickerField,
    BtnAutoComplete,
    simplebar,
  },

  data() {
    return {
      loading: true,
      salvando: false,
      formValido: true,
      menuGarantia: false,
      dialogItem: false,
      formItemValido: true,
      itemEditandoIndex: null,
      dialogConfirmarSair: false,
      snapshotFormulario: null,

      novoItem: {
        tipo: 'P',
        produto: null,
        quantidade: 1,
        unidade: 'UN',
        valorUnitario: '',
        observacao: '',
      },

      rulesItem: {
        produto: [(v) => !!v || 'Informe o item ou peça'],
        quantidade: [(v) => (v !== '' && v !== null && v > 0) || 'Informe uma quantidade válida'],
      },

      rotaFiltros: {
        frota: ROUTE_FROTA,
        operador: ROUTE_OPERADOR,
        executor: ROUTE_OPERADOR,
        propriedade: ROUTE_PROPRIEDADE,
        atividade: ROUTE_ATIVIDADE,
      },

      formulario: {
        id: null,
        uuid: null,
        dataHora: geraData(),
        frota: null,
        operador: null,
        executor: null,
        tipoManutencao: 'I',
        odometro: '',
        tipoOdometro: 'KM',
        evento: null,
        propriedade: null,
        atividade: null,
        garantia: null,
        observacao: '',
        itens: [],
      },

      garantiaDigitada: '',

      autocomplete: {
        frota: [],
        operador: [],
        executor: [],
        propriedade: [],
        atividade: [],
        produto: [],
        evento: [],
      },

      rules: {
        dataHora: [(v) => !!v || 'Data e Hora são obrigatórias'],
        frota: [(v) => !!v || 'Frota é obrigatória'],
        operador: [],
        executor: [(v) => !!v || 'Executor é obrigatório'],
        odometro: [
          (v) => (v !== '' && v !== null && v !== undefined) || 'Odômetro/Horímetro é obrigatório',
          (v) => !v || String(v).length <= 9 || 'Máximo de 9 caracteres',
        ],
        evento: [],
        propriedade: [(v) => !!v || 'Local (Propriedade) é obrigatório'],
        atividade: [],
        garantia: [
          () => this.$_validarGarantia(),
        ],
      },
    };
  },

  computed: {
    cadastroSalvo() {
      return Boolean(this.formulario && (this.formulario.uuid || this.formulario.id));
    },

    veiculoSelecionado() {
      if (!this.formulario || !this.formulario.frota) return false;
      if (typeof this.formulario.frota === 'object') {
        return Object.keys(this.formulario.frota).length > 0;
      }
      return true;
    },

    labelOdometro() {
      return this.formulario.tipoOdometro === 'HH' ? 'Horímetro (HH) *' : 'Odômetro (KM) *';
    },

    totalItensValor() {
      if (!this.formulario.itens || this.formulario.itens.length === 0) return 0;
      return this.formulario.itens.reduce((acc, curr) => acc + (Number(curr.valorTotal) || 0), 0);
    },

    minDataGarantia() {
      const dataCadastroStr = this.$_obterDataString(this.formulario.dataHora);
      if (!dataCadastroStr) return null;
      return moment(dataCadastroStr, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
    },

    alturaCampos() {
      return this.$vuetify.breakpoint.mobile ? 56 : 40;
    },
  },

  watch: {
    formulario: {
      deep: true,
      handler(val) {
        if (!this.loading && val) {
          sessionStorage.setItem(MANUTENCAO_STORAGE.formulario, JSON.stringify(val));
        }
      },
    },
    garantiaDigitada: function watchGarantiaDigitada(val) {
      if (!this.loading) {
        sessionStorage.setItem('MANUTENCAO_GARANTIA_DIGITADA', val || '');
      }
    },
    'formulario.frota': {
      handler(novoVeiculo) {
        if (novoVeiculo) {
          this.$_onFrotaChange(novoVeiculo);
        }
      },
      deep: true,
    },
    'formulario.tipoOdometro': function watchTipoOdometro(novoTipo) {
      if (this.veiculoSelecionado) {
        const tipoEsperado = this.$_obterTipoOdometroVeiculo(this.formulario.frota);
        if (novoTipo !== tipoEsperado) {
          this.$nextTick(() => {
            this.formulario.tipoOdometro = tipoEsperado;
          });
        }
      }
    },
    'formulario.dataHora': function watchDataHora() {
      this.$nextTick(() => {
        if (this.$refs.campoGarantia) {
          this.$refs.campoGarantia.validate(true);
        }
      });
    },
    'formulario.garantia': function watchGarantia(val) {
      if (val) {
        const formatada = this.$_formataDataExibicao(val);
        if (this.garantiaDigitada !== formatada) {
          this.garantiaDigitada = formatada;
        }
      } else {
        this.garantiaDigitada = '';
      }
      this.$nextTick(() => {
        if (this.$refs.campoGarantia) {
          this.$refs.campoGarantia.validate(true);
        }
      });
    },
    'formulario.odometro': function watchOdometro(val) {
      if (val !== null && val !== undefined && String(val).length > 9) {
        this.formulario.odometro = String(val).slice(0, 9);
      }
    },
  },

  methods: {
    $_gerarUuid() {
      if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
      }
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        // eslint-disable-next-line no-bitwise
        const r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-bitwise
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },

    // Métodos para gestão de itens/peças
    $_abrirDialogItem() {
      if (!this.cadastroSalvo) {
        errorHandler('Salve o cadastro da manutenção antes de adicionar itens.');
        return;
      }
      this.itemEditandoIndex = null;
      this.novoItem = {
        id: null,
        imviditemmovimentacaoveiculo: null,
        imvidnuvem: null,
        tipo: 'P',
        produto: null,
        quantidade: 1,
        unidade: 'UN',
        valorUnitario: '',
        observacao: '',
      };
      this.formItemValido = true;
      this.dialogItem = true;
    },

    $_obterProdutoPorItem(it) {
      if (!it) return null;
      const idBusca = it.imvidproduto || it.produto?.proidproduto || it.produto?.id || it.idProduto;
      const descBusca = it.imvdescricaoproduto || it.descricao || it.produto?.prodescricao || (typeof it.produto === 'string' ? it.produto : '');

      let match = null;
      if (idBusca && this.autocomplete.produto && this.autocomplete.produto.length > 0) {
        match = this.autocomplete.produto.find(
          (p) => String(p.proidproduto) === String(idBusca) || String(p.id) === String(idBusca),
        );
      }

      if (!match && descBusca && this.autocomplete.produto && this.autocomplete.produto.length > 0) {
        const descLower = descBusca.trim().toLowerCase();
        match = this.autocomplete.produto.find((p) => {
          const pDesc = (p.prodescricao || '').toLowerCase();
          const pOrig = (p.prodescricaoOriginal || '').toLowerCase();
          return pDesc === descLower || pOrig === descLower;
        });

        if (!match && descBusca.includes(' - ')) {
          const partes = descBusca.split(/\s*-\s*(.+)/);
          if (partes.length >= 2 && partes[0] && partes[1]) {
            const cod = partes[0].trim().toLowerCase();
            const resto = partes[1].trim().toLowerCase();
            match = this.autocomplete.produto.find((p) => {
              const pCod = String(p.procodigo || '').trim().toLowerCase();
              const pOrig = (p.prodescricaoOriginal || p.prodescricao || '').trim().toLowerCase();
              return (pCod && pCod === cod) || (pOrig && pOrig === resto);
            });
          }
        }

        if (!match) {
          match = this.autocomplete.produto.find((p) => {
            const pDesc = (p.prodescricao || '').toLowerCase();
            const pOrig = (p.prodescricaoOriginal || '').toLowerCase();
            return (pOrig && (pOrig.includes(descLower) || descLower.includes(pOrig)))
              || (pDesc && (pDesc.includes(descLower) || descLower.includes(pDesc)));
          });
        }
      }

      if (match) {
        return match;
      }

      if (idBusca || descBusca) {
        const proId = idBusca || 1;
        let precoFallback = null;
        if (it.imvprecounitario != null) {
          precoFallback = it.imvprecounitario;
        } else if (it.valorUnitario != null) {
          precoFallback = it.valorUnitario;
        } else if (it.produto?.proprecoa != null) {
          precoFallback = it.produto.proprecoa;
        }

        let codigoFallback = it.produto?.procodigo || '';
        if (!codigoFallback && descBusca && descBusca.includes(' - ')) {
          const partes = descBusca.split(/\s*-\s*(.+)/);
          if (partes.length >= 2 && partes[0]) {
            codigoFallback = partes[0].trim();
          }
        }

        const fallbackProd = {
          id: proId,
          proidproduto: proId,
          procodigo: codigoFallback,
          prodescricaoOriginal: this.$_obterNomeProduto(it.produto, descBusca),
          prodescricao: descBusca || (it.produto?.prodescricao) || 'Item / Peça',
          proun: it.imvunidadedemedida || it.unidade || it.produto?.proun || 'UN',
          proprecoa: precoFallback,
        };
        if (this.autocomplete.produto) {
          this.autocomplete.produto.unshift(fallbackProd);
        }
        return fallbackProd;
      }

      return null;
    },

    $_obterNomeProduto(produtoObj, descricaoTexto) {
      if (produtoObj && produtoObj.prodescricaoOriginal) {
        return String(produtoObj.prodescricaoOriginal).trim();
      }

      const idProd = produtoObj?.proidproduto || produtoObj?.id;
      if (idProd && this.autocomplete.produto && this.autocomplete.produto.length > 0) {
        const prodMatch = this.autocomplete.produto.find(
          (p) => (p.proidproduto && String(p.proidproduto) === String(idProd))
            || (p.id && String(p.id) === String(idProd)),
        );
        if (prodMatch && prodMatch.prodescricaoOriginal) {
          return String(prodMatch.prodescricaoOriginal).trim();
        }
      }

      const texto = String(descricaoTexto || produtoObj?.prodescricao || produtoObj?.descricao || '').trim();
      if (!texto) return '';

      const codigo = String(produtoObj?.procodigo || '').trim();
      if (codigo) {
        const regexCodigo = new RegExp(`^${codigo.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\s*-\\s*`, 'i');
        if (regexCodigo.test(texto)) {
          return texto.replace(regexCodigo, '').trim();
        }
      }

      if (this.autocomplete.produto && this.autocomplete.produto.length > 0) {
        const descLower = texto.toLowerCase();
        const prodMatch = this.autocomplete.produto.find((p) => {
          const pDesc = (p.prodescricao || '').toLowerCase();
          const pOrig = (p.prodescricaoOriginal || '').toLowerCase();
          return pDesc === descLower || pOrig === descLower;
        });
        if (prodMatch && prodMatch.prodescricaoOriginal) {
          return String(prodMatch.prodescricaoOriginal).trim();
        }
      }

      return texto;
    },

    async $_obterNomeProdutoAsync(produtoObj, descricaoTexto) {
      const nomeSincrono = this.$_obterNomeProduto(produtoObj, descricaoTexto);

      const codigo = String(produtoObj?.procodigo || '').trim();
      if (nomeSincrono && (!codigo || !nomeSincrono.startsWith(`${codigo} - `))) {
        return nomeSincrono;
      }

      const idProd = produtoObj?.proidproduto || produtoObj?.id;
      if (idProd) {
        try {
          const idNum = Number(idProd);
          let pDb = !Number.isNaN(idNum) ? await db.produto.get(idNum) : null;
          if (!pDb) {
            pDb = await db.produto.where('proidproduto').equals(idNum || idProd).first();
          }
          if (pDb && pDb.prodescricao) {
            return String(pDb.prodescricao).trim();
          }
        } catch (e) {
          // ignore
        }
      }

      const texto = String(descricaoTexto || produtoObj?.prodescricao || produtoObj?.descricao || '').trim();
      if (texto && texto.includes(' - ')) {
        const partes = texto.split(/\s*-\s*(.+)/);
        if (partes.length >= 2 && partes[0] && partes[1]) {
          const possivelCodigo = partes[0].trim();
          try {
            const pDb = await db.produto.where({ procodigo: String(possivelCodigo) }).first();
            if (pDb && pDb.prodescricao) {
              return String(pDb.prodescricao).trim();
            }
          } catch (e) {
            // ignore
          }
        }
      }

      return nomeSincrono || '';
    },

    $_obterIdProdutoItem(item) {
      if (!item) return null;
      if (item.imvidproduto !== undefined && item.imvidproduto !== null && item.imvidproduto !== '') {
        return item.imvidproduto;
      }
      return item.produto?.proidproduto || item.produto?.id || null;
    },

    $_obterProcodigoItem(item) {
      if (!item) return '';
      if (item.procodigo) return item.procodigo;
      if (item.produto?.procodigo) return item.produto.procodigo;

      const prod = this.$_obterProdutoPorItem(item);
      if (prod?.procodigo) return prod.procodigo;

      const desc = String(item.descricao || item.imvdescricaoproduto || '').trim();
      if (desc.includes(' - ')) {
        const partes = desc.split(/\s*-\s*(.+)/);
        if (partes.length >= 2 && partes[0]) {
          return partes[0].trim();
        }
      }
      return '';
    },

    $_obterTextoItem(item) {
      if (!item) return '';
      const codigo = this.$_obterProcodigoItem(item);
      const desc = item.descricao || item.produto?.prodescricaoOriginal || item.produto?.prodescricao || 'Item / Peça';
      if (codigo) {
        const regexCodigo = new RegExp(`^${String(codigo).replace(/[.*+?^${}()|[\\]\\]/g, '\\$&')}\\s*-\\s*`, 'i');
        const descLimpa = desc.replace(regexCodigo, '').trim();
        return `${codigo} - ${descLimpa}`;
      }
      return desc;
    },

    $_editarItem(index) {
      const item = this.formulario.itens[index];
      if (!item) return;

      this.itemEditandoIndex = index;
      const produtoObj = this.$_obterProdutoPorItem(item);

      let valorUnitarioInicial = '';
      if (item.valorUnitario !== null && item.valorUnitario !== undefined && item.valorUnitario !== '') {
        valorUnitarioInicial = item.valorUnitario;
      } else if (produtoObj?.proprecoa != null) {
        valorUnitarioInicial = produtoObj.proprecoa;
      }

      this.novoItem = {
        id: item.id || null,
        imviditemmovimentacaoveiculo: item.imviditemmovimentacaoveiculo || null,
        imvidnuvem: item.imvidnuvem || null,
        tipo: (item.tipo === 'M' || item.tipo === 'M.O.') ? 'M' : 'P',
        produto: produtoObj,
        quantidade: item.quantidade != null ? item.quantidade : 1,
        unidade: item.unidade || produtoObj?.proun || 'UN',
        valorUnitario: valorUnitarioInicial,
        observacao: item.observacao || '',
      };
      this.formItemValido = true;
      this.dialogItem = true;
    },

    // Alternar tipo do item diretamente pelo card (P <-> M)
    async $_alternarTipoItem(index) {
      const item = this.formulario.itens[index];
      if (!item) return;
      const novoTipo = (item.tipo === 'M' || item.tipo === 'M.O.') ? 'P' : 'M';
      this.$set(this.formulario.itens, index, {
        ...item,
        tipo: novoTipo,
      });

      if (item.id) {
        try {
          const idNum = Number(item.id);
          let itemDb = !Number.isNaN(idNum) ? await db.itemmovimentacaoveiculo.get(idNum) : null;
          if (!itemDb) itemDb = await db.itemmovimentacaoveiculo.get(item.id);
          if (!itemDb && !Number.isNaN(idNum)) {
            itemDb = await db.itemmovimentacaoveiculo.where('imviditemmovimentacaoveiculo').equals(idNum).first();
          }
          if (itemDb) {
            await db.itemmovimentacaoveiculo.update(itemDb.id, {
              imvtiposervico: novoTipo,
              imvdataalteracao: geraData(),
            });
          }
        } catch (err) {
          console.error('Erro ao atualizar tipo do item no Dexie:', err);
        }
      }
      sessionStorage.setItem(MANUTENCAO_STORAGE.formulario, JSON.stringify(this.formulario));
    },

    $_abrirTelaSelecaoProduto() {
      sessionStorage.setItem(MANUTENCAO_STORAGE.formulario, JSON.stringify(this.formulario));
      sessionStorage.setItem('MANUTENCAO_NOVO_ITEM', JSON.stringify(this.novoItem));
      sessionStorage.setItem('MANUTENCAO_ITEM_EDITANDO_INDEX', JSON.stringify(this.itemEditandoIndex));
      sessionStorage.setItem(MANUTENCAO_STORAGE.campoSelecao, 'produto');
      sessionStorage.setItem('MANUTENCAO_DIALOG_ITEM_ABERTO', 'true');
      if (this.$route.name !== ROUTE_MANUTENCAO_SELECAO.name) {
        this.$router.push({
          name: ROUTE_MANUTENCAO_SELECAO.name,
          query: { campo: 'produto' },
        }).catch((err) => {
          if (err && err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },

    $_fecharDialogItem() {
      this.dialogItem = false;
      this.itemEditandoIndex = null;
      sessionStorage.removeItem('MANUTENCAO_DIALOG_ITEM_ABERTO');
      sessionStorage.removeItem('MANUTENCAO_NOVO_ITEM');
      sessionStorage.removeItem('MANUTENCAO_ITEM_EDITANDO_INDEX');
      sessionStorage.removeItem(MANUTENCAO_STORAGE.campoSelecao);
    },

    $_onProdutoChange(item) {
      if (item && typeof item === 'object') {
        if (item.proun) {
          this.novoItem.unidade = item.proun;
        }
        if (item.proprecoa !== null && item.proprecoa !== undefined && item.proprecoa !== '') {
          this.novoItem.valorUnitario = item.proprecoa;
        }
      }
    },

    async $_confirmarItem() {
      if (!this.$refs.formItem.validate()) {
        return;
      }
      const produtoObj = typeof this.novoItem.produto === 'object' && this.novoItem.produto !== null
        ? this.novoItem.produto
        : this.$_obterProdutoPorItem({ produto: this.novoItem.produto, descricao: this.novoItem.produto });

      const descricaoBruta = produtoObj?.prodescricao || produtoObj?.descricao || String(this.novoItem.produto || '').trim();
      const descricao = await this.$_obterNomeProdutoAsync(produtoObj, descricaoBruta);

      if (!descricao) {
        return;
      }

      const quantidade = Number(this.novoItem.quantidade) || 1;
      const valorUnitario = this.novoItem.valorUnitario !== '' && this.novoItem.valorUnitario !== null
        ? Number(this.novoItem.valorUnitario)
        : null;
      const valorTotal = valorUnitario !== null ? Number((quantidade * valorUnitario).toFixed(2)) : null;

      const tipoItem = (this.novoItem.tipo === 'M' || this.novoItem.tipo === 'M.O.') ? 'M' : 'P';
      const idProduto = Number(produtoObj?.proidproduto || produtoObj?.id) || null;
      const dataAlteracao = geraData();
      const observacao = (this.novoItem.observacao || '').trim();

      const itemExistente = (this.itemEditandoIndex !== null && this.formulario.itens[this.itemEditandoIndex])
        ? this.formulario.itens[this.itemEditandoIndex]
        : null;

      const vinculoCadastro = this.formulario.uuid || this.formulario.id;

      const itemAtualizado = {
        id: itemExistente?.id || null,
        imviditemmovimentacaoveiculo: itemExistente?.imviditemmovimentacaoveiculo || null,
        imvidmovimentacaoveiculo: itemExistente?.imvidmovimentacaoveiculo || vinculoCadastro,
        movimentacaouuid: itemExistente?.movimentacaouuid || this.formulario.uuid || null,
        imvidnuvem: itemExistente?.imvidnuvem || null,
        tipo: tipoItem,
        produto: produtoObj,
        imvidproduto: idProduto,
        procodigo: produtoObj?.procodigo || this.$_obterProcodigoItem(itemExistente || { produto: produtoObj, descricao }) || '',
        descricao,
        quantidade,
        unidade: this.novoItem.unidade || produtoObj?.proun || 'UN',
        valorUnitario,
        valorTotal,
        observacao,
      };

      try {
        if (this.itemEditandoIndex !== null && itemExistente) {
          const idLocal = itemExistente.id;
          let itemDb = null;
          if (idLocal) {
            const idNum = Number(idLocal);
            if (!Number.isNaN(idNum)) {
              itemDb = await db.itemmovimentacaoveiculo.get(idNum);
            }
            if (!itemDb) {
              itemDb = await db.itemmovimentacaoveiculo.get(idLocal);
            }
            if (!itemDb && !Number.isNaN(idNum)) {
              itemDb = await db.itemmovimentacaoveiculo
                .where('imviditemmovimentacaoveiculo')
                .equals(idNum)
                .first();
            }
          }

          if (itemDb) {
            itemAtualizado.id = itemDb.id;
            itemAtualizado.imviditemmovimentacaoveiculo = itemDb.imviditemmovimentacaoveiculo || itemAtualizado.imviditemmovimentacaoveiculo || null;
            itemAtualizado.imvidmovimentacaoveiculo = itemDb.imvidmovimentacaoveiculo || vinculoCadastro;
            itemAtualizado.movimentacaouuid = itemDb.movimentacaouuid || this.formulario.uuid || null;
            itemAtualizado.imvidnuvem = itemDb.imvidnuvem || itemAtualizado.imvidnuvem || null;
            await db.itemmovimentacaoveiculo.update(itemDb.id, {
              imvidmovimentacaoveiculo: itemDb.imvidmovimentacaoveiculo || vinculoCadastro,
              movimentacaouuid: itemDb.movimentacaouuid || this.formulario.uuid || null,
              imvtiposervico: tipoItem,
              imvidproduto: idProduto,
              imvdescricaoproduto: descricao,
              imvunidadedemedida: itemAtualizado.unidade,
              imvquantidade: quantidade,
              imvprecounitario: valorUnitario,
              imvobservacao: observacao,
              imvvalortotal: valorTotal,
              imvdataalteracao: dataAlteracao,
            });
          } else if (vinculoCadastro) {
            const novoItemMovimentacao = {
              imviditemmovimentacaoveiculo: null,
              imvidmovimentacaoveiculo: vinculoCadastro,
              movimentacaouuid: this.formulario.uuid || null,
              imvtiposervico: tipoItem,
              imvidproduto: idProduto,
              imvdescricaoproduto: descricao,
              imvunidadedemedida: itemAtualizado.unidade,
              imvquantidade: quantidade,
              imvprecounitario: valorUnitario,
              imvidlocalarmazenamento: null,
              imvobservacao: observacao,
              imvvalortotal: valorTotal,
              imvdataalteracao: dataAlteracao,
              imvdatanuvem: null,
              imvidnuvem: null,
              imviditemmovimentacaoveiculonuvem: null,
              imvidmovimentacaonuvem: null,
              imvdeletar: 0,
            };
            const idInserido = await db.itemmovimentacaoveiculo.add(novoItemMovimentacao);
            itemAtualizado.id = idInserido;
            itemAtualizado.imviditemmovimentacaoveiculo = null;
            itemAtualizado.imvidmovimentacaoveiculo = vinculoCadastro;
            itemAtualizado.movimentacaouuid = this.formulario.uuid || null;
            itemAtualizado.imvidnuvem = null;
          } else if (idLocal) {
            itemAtualizado.id = idLocal;
          }
          this.$set(this.formulario.itens, this.itemEditandoIndex, itemAtualizado);
          errorHandler('Item atualizado com sucesso!');
        } else {
          // Novo item
          if (vinculoCadastro) {
            const novoItemMovimentacao = {
              imviditemmovimentacaoveiculo: null,
              imvidmovimentacaoveiculo: vinculoCadastro,
              movimentacaouuid: this.formulario.uuid || null,
              imvtiposervico: tipoItem,
              imvidproduto: idProduto,
              imvdescricaoproduto: descricao,
              imvunidadedemedida: itemAtualizado.unidade,
              imvquantidade: quantidade,
              imvprecounitario: valorUnitario,
              imvidlocalarmazenamento: null,
              imvobservacao: observacao,
              imvvalortotal: valorTotal,
              imvdataalteracao: dataAlteracao,
              imvdatanuvem: null,
              imvidnuvem: null,
              imviditemmovimentacaoveiculonuvem: null,
              imvidmovimentacaonuvem: null,
              imvdeletar: 0,
            };
            const idInserido = await db.itemmovimentacaoveiculo.add(novoItemMovimentacao);
            itemAtualizado.id = idInserido;
            itemAtualizado.imviditemmovimentacaoveiculo = null;
            itemAtualizado.imvidmovimentacaoveiculo = vinculoCadastro;
            itemAtualizado.movimentacaouuid = this.formulario.uuid || null;
            itemAtualizado.imvidnuvem = null;
          }
          this.formulario.itens.push(itemAtualizado);
          errorHandler('Item adicionado com sucesso!');
        }
      } catch (err) {
        console.error('Erro ao salvar item no Dexie:', err);
        errorHandler('Erro ao salvar item.');
      }

      sessionStorage.setItem(MANUTENCAO_STORAGE.formulario, JSON.stringify(this.formulario));
      this.$_atualizarSnapshot();
      this.$_fecharDialogItem();
    },

    async $_removerItem(index) {
      const item = this.formulario.itens[index];
      if (!item) return;

      if (item.imviditemmovimentacaoveiculo) {
        errorHandler('Item já salvo na nuvem não pode ser excluído.');
        return;
      }

      if (item && item.id) {
        try {
          const idNum = Number(item.id);
          let itemDb = !Number.isNaN(idNum) ? await db.itemmovimentacaoveiculo.get(idNum) : null;
          if (!itemDb) itemDb = await db.itemmovimentacaoveiculo.get(item.id);
          if (!itemDb && !Number.isNaN(idNum)) {
            itemDb = await db.itemmovimentacaoveiculo.where('imviditemmovimentacaoveiculo').equals(idNum).first();
          }

          if (itemDb) {
            if (itemDb.imviditemmovimentacaoveiculo) {
              errorHandler('Item já salvo na nuvem não pode ser excluído.');
              return;
            }
            if (itemDb.imvidnuvem) {
              await db.itemmovimentacaoveiculo.update(itemDb.id, {
                imvdeletar: 1,
                imvdataalteracao: geraData(),
              });
            } else {
              await db.itemmovimentacaoveiculo.delete(itemDb.id);
            }
          }
        } catch (err) {
          console.error('Erro ao excluir item do Dexie:', err);
        }
      }
      this.formulario.itens.splice(index, 1);
      sessionStorage.setItem(MANUTENCAO_STORAGE.formulario, JSON.stringify(this.formulario));
      this.$_atualizarSnapshot();
      this.$_fecharDialogItem();
      errorHandler('Item removido com sucesso!');
    },

    $_formataMoeda(valor) {
      if (valor == null || valor === '') return 'R$ 0,00';
      const numero = typeof valor === 'number' ? valor : parseFloat(valor);
      if (Number.isNaN(numero)) return valor;
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(numero);
    },

    // Formatação de data (YYYY-MM-DD para DD/MM/YYYY)
    $_formataDataExibicao(data) {
      if (!data) return '';
      const dataLimpa = String(data).slice(0, 10);
      const [ano, mes, dia] = dataLimpa.split('-');
      if (ano && mes && dia) {
        return `${dia}/${mes}/${ano}`;
      }
      return data;
    },

    // Extrai data no formato YYYY-MM-DD para comparações seguras
    $_obterDataString(valor) {
      if (!valor) return null;
      if (typeof valor === 'string') {
        const isoMatch = valor.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (isoMatch) return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}`;
        const brMatch = valor.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
        if (brMatch) return `${brMatch[3]}-${brMatch[2]}-${brMatch[1]}`;
      }
      try {
        const d = new Date(valor);
        // eslint-disable-next-line no-restricted-globals
        if (!isNaN(d.getTime())) {
          return geraData(d, 'YYYY-MM-DD');
        }
      } catch (e) {
        // ignore
      }
      return null;
    },

    // Limpeza da garantia
    $_limparGarantia() {
      this.garantiaDigitada = '';
      this.formulario.garantia = null;
      this.$nextTick(() => {
        if (this.$refs.campoGarantia) {
          this.$refs.campoGarantia.resetValidation();
        }
      });
    },

    // Tratamento ao digitar a data de garantia
    $_onInputGarantia(valor) {
      this.garantiaDigitada = valor || '';
      if (!valor) {
        this.formulario.garantia = null;
        if (this.$refs.campoGarantia) {
          this.$refs.campoGarantia.resetValidation();
        }
        return;
      }
      if (valor.length === 10) {
        const m = moment(valor, 'DD/MM/YYYY', true);
        if (m.isValid()) {
          this.formulario.garantia = m.format('YYYY-MM-DD');
        } else {
          this.formulario.garantia = null;
        }
        if (this.$refs.campoGarantia) {
          this.$refs.campoGarantia.validate(true);
        }
      }
    },

    // Tratamento ao sair do campo (blur) de garantia
    $_onBlurGarantia() {
      if (this.garantiaDigitada && this.garantiaDigitada.length < 10) {
        this.formulario.garantia = null;
      }
      if (this.$refs.campoGarantia) {
        this.$refs.campoGarantia.validate(true);
      }
    },

    // Validação da data de garantia: deve ser sempre maior que a data de cadastro
    $_validarGarantia() {
      const texto = (this.garantiaDigitada || '').trim();
      if (!texto && !this.formulario.garantia) {
        return true;
      }

      let dataGarantiaStr = null;
      if (texto) {
        if (texto.length < 10) {
          return 'Informe a data completa (DD/MM/AAAA)';
        }
        const m = moment(texto, 'DD/MM/YYYY', true);
        if (!m.isValid()) {
          return 'Data de garantia inválida';
        }
        dataGarantiaStr = m.format('YYYY-MM-DD');
      } else if (this.formulario.garantia) {
        dataGarantiaStr = this.$_obterDataString(this.formulario.garantia);
      }

      if (!dataGarantiaStr) {
        return true;
      }

      const dataCadastroStr = this.$_obterDataString(this.formulario.dataHora);

      if (dataCadastroStr && dataGarantiaStr <= dataCadastroStr) {
        return 'A data da garantia deve ser maior que a data de cadastro';
      }

      return true;
    },

    $_filtroFrota(item, queryText) {
      if (!queryText) return true;
      const query = queryText.toLowerCase().trim();
      const placa = (item.veiplaca || '').toLowerCase();
      const marca = (item.veimarca || '').toLowerCase();
      const frota = (item.veifrota || '').toLowerCase();
      const maq = (item.veitipomaquinario || '').toLowerCase();
      const id = String(item.veiidveiculo || item.id || '');

      return placa.includes(query)
        || marca.includes(query)
        || frota.includes(query)
        || maq.includes(query)
        || id.includes(query);
    },

    $_filtroOperador(item, queryText) {
      if (!queryText) return true;
      const query = queryText.toLowerCase().trim();
      const nome = (item.pesnome || '').toLowerCase();
      const fantasia = (item.pesnomefantasia || '').toLowerCase();
      const cpf = (item.pescpf || '').replace(/\D/g, '');
      const queryDigitos = query.replace(/\D/g, '');
      const id = String(item.pesidpessoa || item.id || '');

      return nome.includes(query)
        || fantasia.includes(query)
        || Boolean(queryDigitos && cpf.includes(queryDigitos))
        || id.includes(query);
    },

    $_filtroEvento(item, queryText) {
      if (!queryText) return true;
      const query = queryText.toLowerCase().trim();
      const desc = (item.evvdescricao || item.descricao || '').toLowerCase();
      const id = String(item.evvideventoveiculo || item.id || '');

      return desc.includes(query) || id.includes(query);
    },

    $_filtroPropriedade(item, queryText) {
      if (!queryText) return true;
      const query = queryText.toLowerCase().trim();
      const nome = (item.pronome || '').toLowerCase();
      const id = String(item.proidpropriedade || item.id || '');

      return nome.includes(query) || id.includes(query);
    },

    $_filtroAtividade(item, queryText) {
      if (!queryText) return true;
      const query = queryText.toLowerCase().trim();
      const desc = (item.veadescricao || item.atadescricao || item.descricao || '').toLowerCase();
      const id = String(item.veaidveiculoatividade || item.id || '');

      return desc.includes(query) || id.includes(query);
    },

    $_filtroProduto(item, queryText) {
      if (!queryText) return true;
      const query = queryText.toLowerCase().trim();
      const desc = (item.prodescricao || '').toLowerCase();
      const cod = (item.procodigo || '').toLowerCase();
      const id = String(item.proidproduto || item.id || '');

      return desc.includes(query) || cod.includes(query) || id.includes(query);
    },

    // Identifica o tipo de odômetro (KM ou HH) de acordo com o veículo
    $_obterTipoOdometroVeiculo(item) {
      if (!item) return 'KM';
      if (Number(item.veitipo) === 2 || item.veitipo === 2 || item.veitipomaquinario) {
        return 'HH';
      }
      return 'KM';
    },

    // Ajuste automático do tipo de odômetro ao selecionar o veículo
    $_onFrotaChange(item) {
      if (!item) return;
      this.formulario.tipoOdometro = this.$_obterTipoOdometroVeiculo(item);
    },

    // Limite de 9 caracteres para o campo de odômetro / horímetro (KM / HH)
    $_limitarOdometro(val) {
      if (val !== null && val !== undefined && String(val).length > 9) {
        this.formulario.odometro = String(val).slice(0, 9);
      }
    },

    // Carregamento dos dados do Dexie com fallbacks
    async $_findDb() {
      try {
        const veiculos = await db.veiculo.toArray();
        const veiculosAtivos = veiculos.filter((v) => !v.veideletar);
        const getVal = (val1, val2) => {
          if (val1 != null && String(val1).trim() !== '') {
            return String(val1).trim();
          }
          if (val2 != null && String(val2).trim() !== '') {
            return String(val2).trim();
          }
          return '-';
        };
        this.autocomplete.frota = veiculosAtivos.map((v) => {
          let tipoSufixo = '';
          if (v.veitipo) {
            tipoSufixo = v.veitipo === 2 ? ' (HH)' : ' (KM)';
          }
          const frota = getVal(v.veifrota, v.frota);
          const placa = getVal(v.veiplaca, v.placa);
          const marca = getVal(v.veimarca, v.marca);
          const descricao = `${frota} - ${placa} - ${marca}${tipoSufixo}`;

          return {
            ...v,
            id: v.id || v.veiidveiculo,
            veiidveiculo: v.veiidveiculo || v.id,
            veidescricao: descricao,
          };
        });

        const pessoas = await db.pessoa.toArray();
        const pessoasAtivas = pessoas.filter((p) => !p.pesdeletar);
        this.autocomplete.operador = pessoasAtivas.map((p) => ({
          ...p,
          id: p.id || p.pesidpessoa,
          pesidpessoa: p.pesidpessoa || p.id,
          pesnome: p.pesnome || 'Sem nome',
        })).sort((a, b) => (a.pesnome || '').localeCompare(b.pesnome || ''));

        this.autocomplete.executor = [...this.autocomplete.operador];

        const propriedades = await db.propriedade.toArray();

        const isProDeletado = (p) => {
          const val = String(p.prodeletar ?? '').toUpperCase().trim();
          return val === 'S' || val === 'TRUE' || p.prodeletar === true || p.prodeletar === 1;
        };
        const propriedadesValidas = propriedades.filter((p) => !isProDeletado(p));
        const listaPropriedades = propriedadesValidas.length > 0 ? propriedadesValidas : propriedades;

        this.autocomplete.propriedade = listaPropriedades.map((p) => {
          const nome = p.pronome || (p.proidpropriedade ? `Propriedade #${p.proidpropriedade}` : `Propriedade #${p.id}`);
          const id = p.id || p.proidpropriedade;
          return {
            ...p,
            id,
            proidpropriedade: p.proidpropriedade || id,
            pronome: nome,
          };
        }).sort((a, b) => (a.pronome || '').localeCompare(b.pronome || ''));

        const atividades = await db.veiculoatividade.toArray();

        const isVeaDeletado = (a) => {
          const val = String(a.veadeletar ?? '').toUpperCase().trim();
          return val === 'S' || val === 'TRUE' || a.veadeletar === true || a.veadeletar === 1;
        };
        const isVeaInativo = (a) => {
          const val = String(a.veainativo ?? '').toUpperCase().trim();
          return val === 'S' || val === 'TRUE' || a.veainativo === true || a.veainativo === 1;
        };

        const atividadesNaoDeletadas = atividades.filter((a) => !isVeaDeletado(a));
        const atividadesAtivas = atividadesNaoDeletadas.filter((a) => !isVeaInativo(a));
        const listaAtividades = atividadesAtivas.length > 0 ? atividadesAtivas : atividadesNaoDeletadas;

        this.autocomplete.atividade = listaAtividades.map((a) => {
          const nome = a.veadescricao || a.atadescricao || a.descricao || (a.veaidveiculoatividade ? `Atividade #${a.veaidveiculoatividade}` : `Atividade #${a.id}`);
          const id = a.id || a.veaidveiculoatividade;
          return {
            ...a,
            id,
            veaidveiculoatividade: a.veaidveiculoatividade || id,
            veadescricao: nome,
            atadescricao: nome,
            descricao: nome,
          };
        }).sort((a, b) => (a.veadescricao || '').localeCompare(b.veadescricao || ''));

        const produtos = await db.produto.toArray();
        this.autocomplete.produto = produtos.map((p) => {
          const proId = p.proidproduto || p.id;
          const descOriginal = p.prodescricao || '';
          return {
            ...p,
            id: proId,
            proidproduto: proId,
            procodigo: p.procodigo || '',
            prodescricaoOriginal: descOriginal,
            prodescricao: p.procodigo ? `${p.procodigo} - ${descOriginal}` : descOriginal,
          };
        });

        const eventos = await db.eventosveiculos.toArray();

        const isDeletado = (e) => {
          const val = String(e.evvdeletar ?? '').toUpperCase().trim();
          return val === 'S' || val === 'TRUE' || e.evvdeletar === true || e.evvdeletar === 1;
        };
        const isInativo = (e) => {
          const val = String(e.evvinativo ?? '').toUpperCase().trim();
          return val === 'S' || val === 'TRUE' || e.evvinativo === true || e.evvinativo === 1;
        };

        const eventosNaoDeletados = eventos.filter((e) => !isDeletado(e));
        const eventosAtivos = eventosNaoDeletados.filter((e) => !isInativo(e));
        const listaEventos = eventosAtivos.length > 0 ? eventosAtivos : eventosNaoDeletados;

        this.autocomplete.evento = listaEventos.map((e) => {
          const nome = e.evvdescricao || e.descricao || e.nome || (e.evvideventoveiculo ? `Evento #${e.evvideventoveiculo}` : `Evento #${e.id}`);
          const id = e.id || e.evvideventoveiculo;
          return {
            ...e,
            id,
            evvideventoveiculo: e.evvideventoveiculo || id,
            descricao: nome,
            evvdescricao: nome,
          };
        }).sort((a, b) => (a.evvdescricao || '').localeCompare(b.evvdescricao || ''));
      } catch (error) {
        console.warn('Erro ao carregar dados do Dexie:', error);
      }

      // Sincroniza formulário se veículo já estava selecionado
      if (this.formulario.frota) {
        const id = this.formulario.frota.veiidveiculo || this.formulario.frota.id;
        const placa = this.formulario.frota.veiplaca;
        const match = this.autocomplete.frota.find(
          (v) => (id && (v.veiidveiculo === id || v.id === id)) || (placa && v.veiplaca === placa),
        );
        if (match) {
          this.formulario.frota = match;
        } else {
          this.autocomplete.frota.unshift(this.formulario.frota);
        }
        this.$_onFrotaChange(this.formulario.frota);
      }

      // Sincroniza formulário se operador já estava selecionado
      if (this.formulario.operador) {
        const idPes = this.formulario.operador.pesidpessoa;
        const idLocal = this.formulario.operador.id;
        const nome = this.formulario.operador.pesnome;
        const match = (idPes != null ? this.autocomplete.operador.find(
          (p) => p.pesidpessoa != null && (p.pesidpessoa === idPes || Number(p.pesidpessoa) === Number(idPes)),
        ) : null)
          || (nome ? this.autocomplete.operador.find(
            (p) => p.pesnome && p.pesnome.trim().toLowerCase() === nome.trim().toLowerCase(),
          ) : null)
          || (idLocal != null ? this.autocomplete.operador.find(
            (p) => p.id != null && (p.id === idLocal || Number(p.id) === Number(idLocal)),
          ) : null);
        if (match) {
          this.formulario.operador = match;
        } else {
          this.autocomplete.operador.unshift(this.formulario.operador);
        }
      }

      // Sincroniza formulário se executor já estava selecionado
      if (this.formulario.executor) {
        const idPes = this.formulario.executor.pesidpessoa;
        const idLocal = this.formulario.executor.id;
        const nome = this.formulario.executor.pesnome;
        const match = (idPes != null ? this.autocomplete.executor.find(
          (p) => p.pesidpessoa != null && (p.pesidpessoa === idPes || Number(p.pesidpessoa) === Number(idPes)),
        ) : null)
          || (nome ? this.autocomplete.executor.find(
            (p) => p.pesnome && p.pesnome.trim().toLowerCase() === nome.trim().toLowerCase(),
          ) : null)
          || (idLocal != null ? this.autocomplete.executor.find(
            (p) => p.id != null && (p.id === idLocal || Number(p.id) === Number(idLocal)),
          ) : null);
        if (match) {
          this.formulario.executor = match;
        } else {
          this.autocomplete.executor.unshift(this.formulario.executor);
        }
      }

      // Sincroniza formulário se evento já estava selecionado
      if (this.formulario.evento) {
        const id = this.formulario.evento.evvideventoveiculo || this.formulario.evento.id;
        const desc = this.formulario.evento.evvdescricao || this.formulario.evento.descricao;
        const match = this.autocomplete.evento.find(
          (e) => (id && (e.evvideventoveiculo === id || e.id === id))
            || (desc && (e.descricao === desc || e.evvdescricao === desc)),
        );
        if (match) {
          this.formulario.evento = match;
        } else {
          this.autocomplete.evento.unshift(this.formulario.evento);
        }
      }

      // Sincroniza formulário se propriedade já estava selecionada
      if (this.formulario.propriedade) {
        const id = this.formulario.propriedade.proidpropriedade || this.formulario.propriedade.id;
        const nome = this.formulario.propriedade.pronome;
        const match = this.autocomplete.propriedade.find(
          (p) => (id && (p.proidpropriedade === id || p.id === id)) || (nome && p.pronome === nome),
        );
        if (match) {
          this.formulario.propriedade = match;
        } else {
          this.autocomplete.propriedade.unshift(this.formulario.propriedade);
        }
      }

      // Sincroniza formulário se atividade já estava selecionada
      if (this.formulario.atividade) {
        const id = this.formulario.atividade.veaidveiculoatividade || this.formulario.atividade.id;
        const desc = this.formulario.atividade.veadescricao || this.formulario.atividade.atadescricao || this.formulario.atividade.descricao;
        const match = this.autocomplete.atividade.find(
          (a) => (id && (a.veaidveiculoatividade === id || a.id === id))
            || (desc && (a.veadescricao === desc || a.atadescricao === desc || a.descricao === desc)),
        );
        if (match) {
          this.formulario.atividade = match;
        } else {
          this.autocomplete.atividade.unshift(this.formulario.atividade);
        }
      }

      // Se já temos a manutenção salva no Dexie, restaura itens caso a lista esteja vazia
      if ((this.formulario.uuid || this.formulario.id) && (!this.formulario.itens || this.formulario.itens.length === 0)) {
        try {
          const todosItens = await db.itemmovimentacaoveiculo.toArray();
          const itensDb = todosItens.filter((i) => {
            if (i.imvdeletar) return false;
            const v = i.imvidmovimentacaoveiculo;
            if (this.formulario.uuid && (v === this.formulario.uuid || i.movimentacaouuid === this.formulario.uuid)) {
              return true;
            }
            if (this.formulario.id && (v === this.formulario.id || Number(v) === Number(this.formulario.id))) {
              return true;
            }
            return false;
          });
          if (itensDb && itensDb.length > 0) {
            this.formulario.itens = itensDb.map((it) => {
              const prodObj = this.$_obterProdutoPorItem(it);
              const descPura = this.$_obterNomeProduto(prodObj, it.imvdescricaoproduto) || prodObj?.prodescricaoOriginal || it.imvdescricaoproduto || prodObj?.prodescricao || '';
              let procodigo = String(prodObj?.procodigo || '').trim();
              if (!procodigo && it.imvdescricaoproduto && String(it.imvdescricaoproduto).includes(' - ')) {
                const partes = String(it.imvdescricaoproduto).split(/\s*-\s*(.+)/);
                if (partes.length >= 2 && partes[0]) {
                  procodigo = partes[0].trim();
                }
              }
              return {
                id: it.id,
                imviditemmovimentacaoveiculo: it.imviditemmovimentacaoveiculo || null,
                imvidmovimentacaoveiculo: it.imvidmovimentacaoveiculo || this.formulario.uuid || this.formulario.id || null,
                movimentacaouuid: it.movimentacaouuid || this.formulario.uuid || null,
                imvidnuvem: it.imvidnuvem || null,
                tipo: (it.imvtiposervico === 'M' || it.imvtiposervico === 'M.O.') ? 'M' : 'P',
                produto: prodObj,
                imvidproduto: it.imvidproduto || prodObj?.proidproduto || prodObj?.id || null,
                procodigo,
                descricao: descPura,
                quantidade: it.imvquantidade || 1,
                unidade: it.imvunidadedemedida || prodObj?.proun || 'UN',
                valorUnitario: it.imvprecounitario != null ? it.imvprecounitario : (prodObj?.proprecoa || null),
                valorTotal: it.imvvalortotal,
                observacao: it.imvobservacao || '',
              };
            });
          }
        } catch (err) {
          console.warn('Erro ao carregar itens da manutenção salva:', err);
        }
      }

      // Sincroniza produtos dos itens existentes com o autocomplete e recupera dados do Dexie se necessário
      if (this.formulario.itens && this.formulario.itens.length > 0) {
        this.formulario.itens = await Promise.all(this.formulario.itens.map(async (it) => {
          const prodObj = this.$_obterProdutoPorItem(it);
          let imvId = it.imviditemmovimentacaoveiculo || null;
          let imvNuvem = it.imvidnuvem || null;
          if (!imvId && it.id) {
            try {
              const idNum = Number(it.id);
              const itDb = (!Number.isNaN(idNum) ? await db.itemmovimentacaoveiculo.get(idNum) : null)
                || await db.itemmovimentacaoveiculo.get(it.id);
              if (itDb) {
                if (itDb.imviditemmovimentacaoveiculo) imvId = itDb.imviditemmovimentacaoveiculo;
                if (itDb.imvidnuvem) imvNuvem = itDb.imvidnuvem;
              }
            } catch (e) {
              // ignore
            }
          }
          const descPura = this.$_obterNomeProduto(prodObj || it.produto, it.descricao) || 'Item / Peça';
          let procodigo = String(it.procodigo || prodObj?.procodigo || '').trim();
          if (!procodigo && it.descricao && String(it.descricao).includes(' - ')) {
            const partes = String(it.descricao).split(/\s*-\s*(.+)/);
            if (partes.length >= 2 && partes[0]) {
              procodigo = partes[0].trim();
            }
          }
          return {
            ...it,
            imviditemmovimentacaoveiculo: imvId,
            imvidnuvem: imvNuvem,
            produto: prodObj || it.produto,
            imvidproduto: it.imvidproduto || prodObj?.proidproduto || prodObj?.id || it.produto?.proidproduto || it.produto?.id || null,
            procodigo,
            descricao: descPura,
            unidade: it.unidade || prodObj?.proun || 'UN',
          };
        }));
      }

      // Sincroniza novoItem.produto com a lista de produtos carregada do Dexie se o dialog estiver aberto
      if (this.novoItem && this.novoItem.produto && this.autocomplete.produto && this.autocomplete.produto.length > 0) {
        const prodMatch = this.$_obterProdutoPorItem({ produto: this.novoItem.produto, descricao: this.novoItem.produto });
        if (prodMatch) {
          this.novoItem.produto = prodMatch;
        }
      }

      // Se vier com ID via rota para edição
      const idEditar = this.$route.query.id || this.$route.params.id;
      const temFormStorage = !!sessionStorage.getItem(MANUTENCAO_STORAGE.formulario);
      if (idEditar && (!this.formulario.id || !temFormStorage || (Number(this.formulario.id) !== Number(idEditar) && String(this.formulario.id) !== String(idEditar) && this.formulario.uuid !== idEditar))) {
        await this.$_carregarManutencaoParaEdicao(idEditar);
      }

      if (!sessionStorage.getItem('MANUTENCAO_SNAPSHOT')) {
        this.$_atualizarSnapshot();
      } else {
        this.snapshotFormulario = sessionStorage.getItem('MANUTENCAO_SNAPSHOT');
      }

      this.loading = false;
    },

    async $_carregarManutencaoParaEdicao(idManutencao) {
      if (!idManutencao) return;
      try {
        const idNum = Number(idManutencao);
        let mov = null;
        if (!Number.isNaN(idNum)) {
          mov = await db.movimentacaoveiculo.get(idNum);
        }
        if (!mov) {
          mov = await db.movimentacaoveiculo
            .where('movidmovimentacaoveiculo')
            .equals(idManutencao)
            .or('movidmovimentacaoveiculo')
            .equals(idNum)
            .first();
        }
        if (!mov) {
          mov = await db.movimentacaoveiculo.where('id').equals(idNum).first();
        }
        if (!mov && typeof idManutencao === 'string') {
          mov = await db.movimentacaoveiculo.filter((m) => m.uuid === idManutencao || m.movuuid === idManutencao).first();
        }

        if (!mov) {
          console.warn('Manutenção não encontrada para edição no Dexie ID:', idManutencao);
          return;
        }

        this.formulario.id = mov.id || mov.movidmovimentacaoveiculo;
        this.formulario.uuid = mov.uuid || mov.movuuid || null;
        this.formulario.dataHora = mov.movdata || (mov.movdataalteracao ? geraData(mov.movdataalteracao) : geraData());
        this.formulario.odometro = mov.movvalortipo != null ? String(mov.movvalortipo) : '';
        this.formulario.tipoOdometro = mov.movtipo || 'KM';
        const tipoM = String(mov.movtipomanutencao || '').toUpperCase().trim();
        this.formulario.tipoManutencao = (tipoM === 'E' || tipoM === '2' || tipoM === 'EXTERNA') ? 'E' : 'I';
        this.formulario.observacao = mov.movobservacao || '';
        this.formulario.garantia = mov.movgarantiaate || null;
        if (mov.movgarantiaate) {
          this.garantiaDigitada = this.$_formataDataExibicao(mov.movgarantiaate);
        }

        // 1. Veículo
        if (mov.movidveiculo != null) {
          const idVei = Number(mov.movidveiculo) || mov.movidveiculo;
          const matchVei = this.autocomplete.frota.find(
            (v) => v.veiidveiculo != null && (v.veiidveiculo === idVei || Number(v.veiidveiculo) === Number(idVei)),
          ) || this.autocomplete.frota.find(
            (v) => v.id != null && (v.id === idVei || Number(v.id) === Number(idVei)),
          );
          if (matchVei) {
            this.formulario.frota = matchVei;
            this.$_onFrotaChange(matchVei);
          } else {
            const veiDb = await db.veiculo.where('veiidveiculo').equals(idVei).first()
              || await db.veiculo.get(idVei);
            if (veiDb) {
              const fObj = {
                ...veiDb,
                id: veiDb.id || veiDb.veiidveiculo,
                veiidveiculo: veiDb.veiidveiculo || veiDb.id,
                veidescricao: veiDb.veidescricao || `${veiDb.veifrota || '-'} - ${veiDb.veiplaca || '-'} - ${veiDb.veimarca || '-'}`,
              };
              this.formulario.frota = fObj;
              this.autocomplete.frota.unshift(fObj);
              this.$_onFrotaChange(fObj);
            }
          }
        }

        // 2. Operador (prioriza movidoperador, depois movidpessoa, depois movidfornecedor)
        let idOperador = null;
        if (mov.movidoperador != null) {
          idOperador = mov.movidoperador;
        } else if (mov.movidpessoa != null) {
          idOperador = mov.movidpessoa;
        } else if (mov.movidfornecedor != null) {
          idOperador = mov.movidfornecedor;
        }
        if (idOperador != null) {
          const idP = Number(idOperador) || idOperador;
          const matchPes = this.autocomplete.operador.find(
            (p) => p.pesidpessoa != null && (p.pesidpessoa === idP || Number(p.pesidpessoa) === Number(idP)),
          ) || this.autocomplete.operador.find(
            (p) => p.id != null && (p.id === idP || Number(p.id) === Number(idP)),
          );
          if (matchPes) {
            this.formulario.operador = matchPes;
          } else {
            const pesDb = await db.pessoa.where('pesidpessoa').equals(idP).first()
              || await db.pessoa.get(idP);
            if (pesDb) {
              const pObj = { ...pesDb, id: pesDb.id || pesDb.pesidpessoa };
              this.formulario.operador = pObj;
              this.autocomplete.operador.unshift(pObj);
            }
          }
        }

        // 2.1. Executor
        if (mov.movidpessoaexecutor != null) {
          const idE = Number(mov.movidpessoaexecutor) || mov.movidpessoaexecutor;
          const matchExec = this.autocomplete.executor.find(
            (p) => p.pesidpessoa != null && (p.pesidpessoa === idE || Number(p.pesidpessoa) === Number(idE)),
          ) || this.autocomplete.executor.find(
            (p) => p.id != null && (p.id === idE || Number(p.id) === Number(idE)),
          );
          if (matchExec) {
            this.formulario.executor = matchExec;
          } else {
            const execDb = await db.pessoa.where('pesidpessoa').equals(idE).first()
              || await db.pessoa.get(idE);
            if (execDb) {
              const eObj = { ...execDb, id: execDb.id || execDb.pesidpessoa };
              this.formulario.executor = eObj;
              this.autocomplete.executor.unshift(eObj);
            }
          }
        }

        // 3. Propriedade
        if (mov.movidpropriedade != null) {
          const idPro = Number(mov.movidpropriedade) || mov.movidpropriedade;
          const matchPro = this.autocomplete.propriedade.find(
            (pr) => pr.proidpropriedade != null && (pr.proidpropriedade === idPro || Number(pr.proidpropriedade) === Number(idPro)),
          ) || this.autocomplete.propriedade.find(
            (pr) => pr.id != null && (pr.id === idPro || Number(pr.id) === Number(idPro)),
          );
          if (matchPro) {
            this.formulario.propriedade = matchPro;
          } else {
            const proDb = await db.propriedade.where('proidpropriedade').equals(idPro).first()
              || await db.propriedade.get(idPro);
            if (proDb) {
              const prObj = { ...proDb, id: proDb.id || proDb.proidpropriedade };
              this.formulario.propriedade = prObj;
              this.autocomplete.propriedade.unshift(prObj);
            }
          }
        }

        // 4. Evento
        if (mov.movideventoveiculo != null) {
          const idEv = Number(mov.movideventoveiculo) || mov.movideventoveiculo;
          const matchEv = this.autocomplete.evento.find(
            (e) => e.evvideventoveiculo != null && (e.evvideventoveiculo === idEv || Number(e.evvideventoveiculo) === Number(idEv)),
          ) || this.autocomplete.evento.find(
            (e) => e.id != null && (e.id === idEv || Number(e.id) === Number(idEv)),
          );
          if (matchEv) {
            this.formulario.evento = matchEv;
          } else {
            const evDb = await db.eventosveiculos.where('evvideventoveiculo').equals(idEv).first()
              || await db.eventosveiculos.get(idEv);
            if (evDb) {
              const eObj = { ...evDb, id: evDb.id || evDb.evvideventoveiculo, descricao: evDb.evvdescricao || evDb.descricao };
              this.formulario.evento = eObj;
              this.autocomplete.evento.unshift(eObj);
            }
          }
        }

        // 5. Atividade
        if (mov.movidatividade != null) {
          const idAt = String(mov.movidatividade);
          const matchAt = this.autocomplete.atividade.find(
            (a) => String(a.veaidveiculoatividade) === idAt || String(a.id) === idAt,
          );
          if (matchAt) {
            this.formulario.atividade = matchAt;
          } else if (db.veiculoatividade) {
            const atDb = await db.veiculoatividade.get(Number(idAt) || idAt)
              || await db.veiculoatividade.where('veaidveiculoatividade').equals(Number(idAt) || idAt).first();
            if (atDb) {
              const aObj = { ...atDb, id: atDb.id || atDb.veaidveiculoatividade, veadescricao: atDb.veadescricao || atDb.atadescricao || atDb.descricao };
              this.formulario.atividade = aObj;
              this.autocomplete.atividade.unshift(aObj);
            }
          }
        }

        // 6. Itens
        const todosItens = await db.itemmovimentacaoveiculo.toArray();
        const itensFiltrados = todosItens.filter((it) => {
          if (it.imvdeletar) return false;
          const v = it.imvidmovimentacaoveiculo;
          const vNuvem = it.imvidmovimentacaonuvem;
          return (mov.uuid && (v === mov.uuid || it.movimentacaouuid === mov.uuid))
            || (mov.id && (v === mov.id || Number(v) === Number(mov.id)))
            || (mov.movidmovimentacaoveiculo && (v === mov.movidmovimentacaoveiculo || Number(v) === Number(mov.movidmovimentacaoveiculo)))
            || (mov.movidnuvem && (v === mov.movidnuvem || vNuvem === mov.movidnuvem));
        });

        this.formulario.itens = itensFiltrados.map((it) => {
          const prodObj = this.$_obterProdutoPorItem(it);
          const descPura = this.$_obterNomeProduto(prodObj, it.imvdescricaoproduto) || prodObj?.prodescricaoOriginal || it.imvdescricaoproduto || prodObj?.prodescricao || 'Peça / Item';
          let procodigo = String(prodObj?.procodigo || '').trim();
          if (!procodigo && it.imvdescricaoproduto && String(it.imvdescricaoproduto).includes(' - ')) {
            const partes = String(it.imvdescricaoproduto).split(/\s*-\s*(.+)/);
            if (partes.length >= 2 && partes[0]) {
              procodigo = partes[0].trim();
            }
          }
          return {
            id: it.id,
            imviditemmovimentacaoveiculo: it.imviditemmovimentacaoveiculo || null,
            imvidmovimentacaoveiculo: it.imvidmovimentacaoveiculo || mov.uuid || mov.id || null,
            movimentacaouuid: it.movimentacaouuid || mov.uuid || null,
            imvidnuvem: it.imvidnuvem || null,
            tipo: (it.imvtiposervico === 'M' || it.imvtiposervico === 2 || it.tipo === 'M' || it.tipo === 'M.O.') ? 'M' : 'P',
            produto: prodObj,
            imvidproduto: it.imvidproduto || prodObj?.proidproduto || prodObj?.id || null,
            procodigo,
            descricao: descPura,
            quantidade: it.imvquantidade || 1,
            unidade: it.imvunidadedemedida || prodObj?.proun || 'UN',
            valorUnitario: it.imvprecounitario != null ? it.imvprecounitario : (prodObj?.proprecoa || null),
            valorTotal: it.imvvalortotal,
            observacao: it.imvobservacao || '',
          };
        });

        sessionStorage.setItem(MANUTENCAO_STORAGE.formulario, JSON.stringify(this.formulario));
        this.$_atualizarSnapshot();
      } catch (err) {
        console.warn('Erro ao carregar manutenção para edição:', err);
      }
    },

    // Ação ao salvar formulário
    async $_salvaDados() {
      // Sincroniza garantia caso tenha sido digitada
      if (this.garantiaDigitada && this.garantiaDigitada.length === 10) {
        const m = moment(this.garantiaDigitada, 'DD/MM/YYYY', true);
        if (m.isValid()) {
          this.formulario.garantia = m.format('YYYY-MM-DD');
        }
      }

      const validacaoGarantia = this.$_validarGarantia();
      if (validacaoGarantia !== true) {
        if (this.$refs.campoGarantia) {
          this.$refs.campoGarantia.validate(true);
        }
        errorHandler(validacaoGarantia);
        return false;
      }

      if (!this.$refs.form.validate()) {
        errorHandler('Por favor, preencha todos os campos obrigatórios.');
        return false;
      }

      this.salvando = true;

      try {
        // 1. Obter empresa
        const emp = (await db.empresa.get(1)) || {};
        const idEmpresa = Number(this.formulario.frota?.veiidempresa || emp.empidempresa || 1);

        // 2. Extrair IDs das entidades relacionadas
        const idVeiculo = Number(this.formulario.frota?.veiidveiculo || this.formulario.frota?.id) || null;
        const idPessoa = Number(this.formulario.operador?.pesidpessoa || this.formulario.operador?.id) || null;
        const idExecutor = Number(this.formulario.executor?.pesidpessoa || this.formulario.executor?.id) || null;
        const tipoManutencaoVal = (this.formulario.tipoManutencao === 'E' || this.formulario.tipoManutencao === 'Externa') ? 'E' : 'I';
        const idPropriedade = Number(this.formulario.propriedade?.proidpropriedade || this.formulario.propriedade?.id) || null;
        const idEvento = Number(this.formulario.evento?.evvideventoveiculo || this.formulario.evento?.id) || null;

        let idAtividade = null;
        if (this.formulario.atividade) {
          if (this.formulario.atividade.veaidveiculoatividade) {
            idAtividade = String(this.formulario.atividade.veaidveiculoatividade);
          } else if (this.formulario.atividade.id) {
            idAtividade = String(this.formulario.atividade.id);
          } else if (this.formulario.atividade.ataidatividadeabastecimento) {
            idAtividade = String(this.formulario.atividade.ataidatividadeabastecimento);
          } else if (this.formulario.atividade.atacodigo) {
            idAtividade = String(this.formulario.atividade.atacodigo);
          }
        }

        const dataAlteracao = geraDataNuvem();
        const dataFormatada = this.formulario.dataHora || geraData();
        const garantiaFormatada = this.formulario.garantia ? `${this.formulario.garantia} 00:00:00` : null;
        const odometro = (this.formulario.odometro !== '' && this.formulario.odometro !== null && this.formulario.odometro !== undefined)
          ? Number(this.formulario.odometro)
          : null;

        let idMovimentacao = this.formulario.id;
        let uuidMovimentacao = this.formulario.uuid;

        if (!uuidMovimentacao) {
          uuidMovimentacao = this.$_gerarUuid();
          this.formulario.uuid = uuidMovimentacao;
        }

        if (!idMovimentacao) {
          // 3. Montar objeto com os campos de MovimentacaoVeiculoModel para novo cadastro
          const novaMovimentacao = {
            uuid: uuidMovimentacao,
            movuuid: uuidMovimentacao,
            movidmovimentacaoveiculo: null,
            movidveiculo: idVeiculo,
            movideventoveiculo: idEvento,
            movidfornecedor: idPessoa,
            movidoperador: idPessoa,
            movvalortipo: odometro,
            movdata: dataFormatada,
            movidatividade: idAtividade,
            movobservacao: this.formulario.observacao ? String(this.formulario.observacao).slice(0, 500) : '',
            movtipo: this.formulario.tipoOdometro || 'KM',
            movtipomanutencao: tipoManutencaoVal,
            movidpessoaexecutor: idExecutor,
            movidpropriedade: idPropriedade,
            movgarantiaate: garantiaFormatada,
            movidempresa: idEmpresa,
            movdatanuvem: null,
            movdataalteracao: dataAlteracao,
            movidnuvem: null,
            movidmovimentacaonuvem: null,
            movdeletar: 0,
          };

          // 4. Salvar na tabela movimentacaoveiculo do Dexie
          const idInserido = await db.movimentacaoveiculo.add(novaMovimentacao);
          this.formulario.id = idInserido;
          idMovimentacao = idInserido;

          errorHandler('Cadastro da manutenção salvo com sucesso! Adição de itens liberada.');
        } else {
          // Atualização dos dados do cabeçalho já existente
          const dadosAtualizacao = {
            uuid: uuidMovimentacao,
            movuuid: uuidMovimentacao,
            movidveiculo: idVeiculo,
            movideventoveiculo: idEvento,
            movidfornecedor: idPessoa,
            movidoperador: idPessoa,
            movvalortipo: odometro,
            movdata: dataFormatada,
            movidatividade: idAtividade,
            movobservacao: this.formulario.observacao ? String(this.formulario.observacao).slice(0, 500) : '',
            movtipo: this.formulario.tipoOdometro || 'KM',
            movtipomanutencao: tipoManutencaoVal,
            movidpessoaexecutor: idExecutor,
            movidpropriedade: idPropriedade,
            movgarantiaate: garantiaFormatada,
            movidempresa: idEmpresa,
            movdataalteracao: dataAlteracao,
          };

          await db.movimentacaoveiculo.update(idMovimentacao, dadosAtualizacao);

          errorHandler('Manutenção atualizada com sucesso!');
        }

        // 4.1. Salvar / Atualizar itens na tabela itemmovimentacaoveiculo do Dexie
        if (this.formulario.itens && this.formulario.itens.length > 0) {
          const vinculoMovimentacao = uuidMovimentacao || idMovimentacao;
          for (let i = 0; i < this.formulario.itens.length; i += 1) {
            const item = this.formulario.itens[i];
            const idProduto = Number(item.produto?.proidproduto || item.produto?.id) || null;
            const quantidade = Number(item.quantidade) || 1;
            const precoUnitario = (item.valorUnitario !== '' && item.valorUnitario !== null && item.valorUnitario !== undefined)
              ? Number(item.valorUnitario)
              : null;
            let valorTotal = null;
            if (item.valorTotal !== '' && item.valorTotal !== null && item.valorTotal !== undefined) {
              valorTotal = Number(item.valorTotal);
            } else if (precoUnitario !== null) {
              valorTotal = Number((quantidade * precoUnitario).toFixed(2));
            }

            const tipoFinal = (item.tipo === 'M' || item.tipo === 'M.O.') ? 'M' : 'P';
            const descricaoBruta = item.descricao || item.produto?.prodescricao || '';
            const descricaoFinal = await this.$_obterNomeProdutoAsync(item.produto, descricaoBruta);
            const unidadeFinal = item.unidade || item.produto?.proun || 'UN';
            const observacaoFinal = item.observacao ? String(item.observacao).slice(0, 500) : '';

            let itemDb = null;
            if (item.id) {
              const idNum = Number(item.id);
              if (!Number.isNaN(idNum)) {
                itemDb = await db.itemmovimentacaoveiculo.get(idNum);
              }
              if (!itemDb) {
                itemDb = await db.itemmovimentacaoveiculo.get(item.id);
              }
              if (!itemDb && !Number.isNaN(idNum)) {
                itemDb = await db.itemmovimentacaoveiculo.where('imviditemmovimentacaoveiculo').equals(idNum).first();
              }
            }

            if (itemDb) {
              await db.itemmovimentacaoveiculo.update(itemDb.id, {
                imvidmovimentacaoveiculo: vinculoMovimentacao,
                movimentacaouuid: uuidMovimentacao || null,
                imvtiposervico: tipoFinal,
                imvidproduto: idProduto,
                imvdescricaoproduto: descricaoFinal,
                imvunidadedemedida: unidadeFinal,
                imvquantidade: quantidade,
                imvprecounitario: precoUnitario,
                imvobservacao: observacaoFinal,
                imvvalortotal: valorTotal,
                imvdataalteracao: dataAlteracao,
              });
              this.$set(this.formulario.itens[i], 'id', itemDb.id);
              this.$set(this.formulario.itens[i], 'imvidmovimentacaoveiculo', vinculoMovimentacao);
              this.$set(this.formulario.itens[i], 'movimentacaouuid', uuidMovimentacao || null);
              this.$set(this.formulario.itens[i], 'descricao', descricaoFinal);
              this.$set(this.formulario.itens[i], 'imvidproduto', idProduto);
              if (itemDb.imviditemmovimentacaoveiculo) {
                this.$set(this.formulario.itens[i], 'imviditemmovimentacaoveiculo', itemDb.imviditemmovimentacaoveiculo);
              }
              if (itemDb.imvidnuvem) {
                this.$set(this.formulario.itens[i], 'imvidnuvem', itemDb.imvidnuvem);
              }
            } else {
              const novoItemMovimentacao = {
                imviditemmovimentacaoveiculo: item.imviditemmovimentacaoveiculo || null,
                imvidmovimentacaoveiculo: vinculoMovimentacao,
                movimentacaouuid: uuidMovimentacao || null,
                imvtiposervico: tipoFinal,
                imvidproduto: idProduto,
                imvdescricaoproduto: descricaoFinal,
                imvunidadedemedida: unidadeFinal,
                imvquantidade: quantidade,
                imvprecounitario: precoUnitario,
                imvidlocalarmazenamento: null,
                imvobservacao: observacaoFinal,
                imvvalortotal: valorTotal,
                imvdataalteracao: dataAlteracao,
                imvdatanuvem: null,
                imvidnuvem: item.imvidnuvem || null,
                imviditemmovimentacaoveiculonuvem: null,
                imvidmovimentacaonuvem: null,
                imvdeletar: 0,
              };

              const idItemInserido = await db.itemmovimentacaoveiculo.add(novoItemMovimentacao);
              this.$set(this.formulario.itens[i], 'id', idItemInserido);
              this.$set(this.formulario.itens[i], 'imvidmovimentacaoveiculo', vinculoMovimentacao);
              this.$set(this.formulario.itens[i], 'movimentacaouuid', uuidMovimentacao || null);
              this.$set(this.formulario.itens[i], 'descricao', descricaoFinal);
              this.$set(this.formulario.itens[i], 'imvidproduto', idProduto);
              this.$set(this.formulario.itens[i], 'imviditemmovimentacaoveiculo', novoItemMovimentacao.imviditemmovimentacaoveiculo);
              this.$set(this.formulario.itens[i], 'imvidnuvem', novoItemMovimentacao.imvidnuvem);
            }
          }
        }

        // 4.2. Sincroniza exclusões de itens no Dexie se houver
        if (idMovimentacao || uuidMovimentacao) {
          const idsAtuais = this.formulario.itens.map((it) => it.id).filter(Boolean);
          const todosItensMov = await db.itemmovimentacaoveiculo
            .filter((it) => {
              if (uuidMovimentacao && (it.imvidmovimentacaoveiculo === uuidMovimentacao || it.movimentacaouuid === uuidMovimentacao)) {
                return true;
              }
              if (idMovimentacao && (it.imvidmovimentacaoveiculo === idMovimentacao || Number(it.imvidmovimentacaoveiculo) === Number(idMovimentacao))) {
                return true;
              }
              return false;
            })
            .toArray();
          for (const itDex of todosItensMov) {
            if (!idsAtuais.includes(itDex.id) && !itDex.imvdeletar && !itDex.imviditemmovimentacaoveiculo) {
              if (itDex.imvidnuvem) {
                await db.itemmovimentacaoveiculo.update(itDex.id, {
                  imvdeletar: 1,
                  imvdataalteracao: dataAlteracao,
                });
              } else {
                await db.itemmovimentacaoveiculo.delete(itDex.id);
              }
            }
          }
        }

        // Salvar dados atualizados no sessionStorage
        sessionStorage.setItem(MANUTENCAO_STORAGE.formulario, JSON.stringify(this.formulario));
        this.$_atualizarSnapshot();

        return true;
      } catch (error) {
        console.error('Erro ao salvar manutenção no Dexie:', error);
        errorHandler('Ocorreu um erro ao salvar o registro no banco local.');
        return false;
      } finally {
        this.salvando = false;
      }
    },

    $_sincronizarGarantiaDigitada() {
      if (this.garantiaDigitada && this.garantiaDigitada.length === 10) {
        const m = moment(this.garantiaDigitada, 'DD/MM/YYYY', true);
        if (m.isValid()) {
          this.formulario.garantia = m.format('YYYY-MM-DD');
        }
      } else if (!this.garantiaDigitada) {
        this.formulario.garantia = null;
      }
    },

    $_temAlteracoes() {
      this.$_sincronizarGarantiaDigitada();
      if (!this.snapshotFormulario) {
        return Boolean(
          this.formulario.frota
          || this.formulario.operador
          || this.formulario.executor
          || this.formulario.odometro
          || this.formulario.observacao
          || this.formulario.evento
          || this.formulario.propriedade
          || this.formulario.atividade
          || this.formulario.garantia
          || this.garantiaDigitada
          || (this.formulario.itens && this.formulario.itens.length > 0),
        );
      }

      const formAtualStr = JSON.stringify(this.formulario);
      if (formAtualStr !== this.snapshotFormulario) {
        return true;
      }

      const garantiaAtual = this.garantiaDigitada || '';
      const garantiaSnapshot = sessionStorage.getItem('MANUTENCAO_SNAPSHOT_GARANTIA') || '';
      if (garantiaAtual !== garantiaSnapshot) {
        return true;
      }

      return false;
    },

    // Ação ao clicar no botão voltar / cancelar
    $_cancelar() {
      if (!this.$_temAlteracoes()) {
        this.$_confirmarSair();
        return;
      }
      this.dialogConfirmarSair = true;
    },

    // Ação ao confirmar saída (limpa dados temporários e volta para a listagem de manutenção)
    $_confirmarSair() {
      this.dialogConfirmarSair = false;
      this.$_limparStorageManutencao();
      sessionStorage.removeItem(ROTA_STORAGE.cadastro);
      this.$router.replace({
        name: ROUTE_MANUTENCAO_FROTA.name,
      });
    },

    $_sairSemManter() {
      this.$_confirmarSair();
    },

    $_manterFormulario() {
      this.$_confirmarSair();
    },

    // Métodos para a Tela de Seleção (aberta via ícone do btn-auto-complete)
    $_abrirTelaSelecao(campo) {
      sessionStorage.setItem(MANUTENCAO_STORAGE.formulario, JSON.stringify(this.formulario));
      sessionStorage.setItem(MANUTENCAO_STORAGE.campoSelecao, campo);
      if (this.$route.name !== ROUTE_MANUTENCAO_SELECAO.name) {
        this.$router.push({
          name: ROUTE_MANUTENCAO_SELECAO.name,
          query: { campo },
        }).catch((err) => {
          if (err && err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },

    $_recuperarFormulario() {
      try {
        const formStr = sessionStorage.getItem(MANUTENCAO_STORAGE.formulario);
        if (formStr) {
          const formSalvo = JSON.parse(formStr);
          this.formulario = {
            ...this.formulario,
            ...formSalvo,
          };
          if (this.formulario.frota) {
            this.$_onFrotaChange(this.formulario.frota);
          }
        }

        const campoSelecao = sessionStorage.getItem(MANUTENCAO_STORAGE.campoSelecao);
        const dialogItemAberto = sessionStorage.getItem('MANUTENCAO_DIALOG_ITEM_ABERTO') === 'true';
        const itemSelecionadoStr = sessionStorage.getItem(MANUTENCAO_STORAGE.itemSelecionado);

        if (itemSelecionadoStr) {
          const { campo, item } = JSON.parse(itemSelecionadoStr);
          if (campo === 'produto') {
            const itemEditandoIndexSalvo = sessionStorage.getItem('MANUTENCAO_ITEM_EDITANDO_INDEX');
            const novoItemSalvo = sessionStorage.getItem('MANUTENCAO_NOVO_ITEM');
            this.itemEditandoIndex = itemEditandoIndexSalvo ? JSON.parse(itemEditandoIndexSalvo) : null;
            const itemSalvo = novoItemSalvo ? JSON.parse(novoItemSalvo) : {};

            if (item) {
              this.novoItem = {
                id: itemSalvo.id || null,
                imviditemmovimentacaoveiculo: itemSalvo.imviditemmovimentacaoveiculo || null,
                imvidnuvem: itemSalvo.imvidnuvem || null,
                tipo: (itemSalvo.tipo === 'M' || itemSalvo.tipo === 'M.O.') ? 'M' : 'P',
                produto: item,
                quantidade: itemSalvo.quantidade || 1,
                unidade: item.proun || itemSalvo.unidade || 'UN',
                valorUnitario: (item.proprecoa !== undefined && item.proprecoa !== null)
                  ? item.proprecoa
                  : (itemSalvo.valorUnitario || ''),
                observacao: itemSalvo.observacao || '',
              };
            } else {
              this.novoItem = {
                id: itemSalvo.id || null,
                imviditemmovimentacaoveiculo: itemSalvo.imviditemmovimentacaoveiculo || null,
                imvidnuvem: itemSalvo.imvidnuvem || null,
                tipo: (itemSalvo.tipo === 'M' || itemSalvo.tipo === 'M.O.') ? 'M' : 'P',
                produto: null,
                quantidade: itemSalvo.quantidade || 1,
                unidade: itemSalvo.unidade || 'UN',
                valorUnitario: itemSalvo.valorUnitario != null ? itemSalvo.valorUnitario : '',
                observacao: itemSalvo.observacao || '',
              };
            }
            this.dialogItem = true;
            sessionStorage.removeItem('MANUTENCAO_NOVO_ITEM');
            sessionStorage.removeItem('MANUTENCAO_ITEM_EDITANDO_INDEX');
            sessionStorage.removeItem('MANUTENCAO_DIALOG_ITEM_ABERTO');
          } else if (campo) {
            this.formulario[campo] = item;
            if (campo === 'frota') {
              this.$_onFrotaChange(item);
              if (item) {
                const idVei = item.veiidveiculo;
                const idLocal = item.id;
                const placa = item.veiplaca;
                const match = (idVei != null ? this.autocomplete.frota.find(
                  (v) => v.veiidveiculo != null && (v.veiidveiculo === idVei || Number(v.veiidveiculo) === Number(idVei)),
                ) : null)
                  || (placa ? this.autocomplete.frota.find(
                    (v) => v.veiplaca && v.veiplaca.trim().toUpperCase() === placa.trim().toUpperCase(),
                  ) : null)
                  || (idLocal != null ? this.autocomplete.frota.find(
                    (v) => v.id != null && (v.id === idLocal || Number(v.id) === Number(idLocal)),
                  ) : null);
                if (match) {
                  this.formulario.frota = match;
                } else {
                  this.formulario.frota = item;
                  this.autocomplete.frota.unshift(item);
                }
              }
            } else if (campo === 'operador') {
              if (item) {
                const idPes = item.pesidpessoa;
                const idLocal = item.id;
                const nome = item.pesnome;
                const match = (idPes != null ? this.autocomplete.operador.find(
                  (p) => p.pesidpessoa != null && (p.pesidpessoa === idPes || Number(p.pesidpessoa) === Number(idPes)),
                ) : null)
                  || (nome ? this.autocomplete.operador.find(
                    (p) => p.pesnome && p.pesnome.trim().toLowerCase() === nome.trim().toLowerCase(),
                  ) : null)
                  || (idLocal != null ? this.autocomplete.operador.find(
                    (p) => p.id != null && (p.id === idLocal || Number(p.id) === Number(idLocal)),
                  ) : null);
                if (match) {
                  this.formulario.operador = match;
                } else {
                  this.formulario.operador = item;
                  this.autocomplete.operador.unshift(item);
                }
              }
            } else if (campo === 'executor') {
              if (item) {
                const idPes = item.pesidpessoa;
                const idLocal = item.id;
                const nome = item.pesnome;
                const match = (idPes != null ? this.autocomplete.executor.find(
                  (p) => p.pesidpessoa != null && (p.pesidpessoa === idPes || Number(p.pesidpessoa) === Number(idPes)),
                ) : null)
                  || (nome ? this.autocomplete.executor.find(
                    (p) => p.pesnome && p.pesnome.trim().toLowerCase() === nome.trim().toLowerCase(),
                  ) : null)
                  || (idLocal != null ? this.autocomplete.executor.find(
                    (p) => p.id != null && (p.id === idLocal || Number(p.id) === Number(idLocal)),
                  ) : null);
                if (match) {
                  this.formulario.executor = match;
                } else {
                  this.formulario.executor = item;
                  this.autocomplete.executor.unshift(item);
                }
              }
            } else if (campo === 'evento') {
              if (item) {
                const idEv = item.evvideventoveiculo;
                const idLocal = item.id;
                const desc = item.evvdescricao || item.descricao;
                const match = (idEv != null ? this.autocomplete.evento.find(
                  (e) => e.evvideventoveiculo != null && (e.evvideventoveiculo === idEv || Number(e.evvideventoveiculo) === Number(idEv)),
                ) : null)
                  || (desc ? this.autocomplete.evento.find(
                    (e) => (e.evvdescricao && e.evvdescricao.trim().toLowerCase() === desc.trim().toLowerCase())
                      || (e.descricao && e.descricao.trim().toLowerCase() === desc.trim().toLowerCase()),
                  ) : null)
                  || (idLocal != null ? this.autocomplete.evento.find(
                    (e) => e.id != null && (e.id === idLocal || Number(e.id) === Number(idLocal)),
                  ) : null);
                if (match) {
                  this.formulario.evento = match;
                } else {
                  this.formulario.evento = item;
                  this.autocomplete.evento.unshift(item);
                }
              }
            } else if (campo === 'propriedade') {
              if (item) {
                const idPro = item.proidpropriedade;
                const idLocal = item.id;
                const nome = item.pronome;
                const match = (idPro != null ? this.autocomplete.propriedade.find(
                  (p) => p.proidpropriedade != null && (p.proidpropriedade === idPro || Number(p.proidpropriedade) === Number(idPro)),
                ) : null)
                  || (nome ? this.autocomplete.propriedade.find(
                    (p) => p.pronome && p.pronome.trim().toLowerCase() === nome.trim().toLowerCase(),
                  ) : null)
                  || (idLocal != null ? this.autocomplete.propriedade.find(
                    (p) => p.id != null && (p.id === idLocal || Number(p.id) === Number(idLocal)),
                  ) : null);
                if (match) {
                  this.formulario.propriedade = match;
                } else {
                  this.formulario.propriedade = item;
                  this.autocomplete.propriedade.unshift(item);
                }
              }
            } else if (campo === 'atividade') {
              if (this.autocomplete.atividade && this.autocomplete.atividade.length > 0 && item) {
                const id = item.veaidveiculoatividade || item.id;
                const desc = item.veadescricao || item.atadescricao || item.descricao;
                const match = this.autocomplete.atividade.find(
                  (a) => (id && (a.veaidveiculoatividade === id || a.id === id))
                    || (desc && (a.veadescricao === desc || a.atadescricao === desc || a.descricao === desc)),
                );
                if (match) {
                  this.formulario.atividade = match;
                } else {
                  this.autocomplete.atividade.unshift(item);
                }
              }
            }
          }
          sessionStorage.removeItem(MANUTENCAO_STORAGE.itemSelecionado);
        } else if (campoSelecao === 'produto' || dialogItemAberto) {
          // Voltou da tela de seleção sem escolher nenhum item (ex: clicou na seta voltar no AppBar)
          const itemEditandoIndexSalvo = sessionStorage.getItem('MANUTENCAO_ITEM_EDITANDO_INDEX');
          const novoItemSalvo = sessionStorage.getItem('MANUTENCAO_NOVO_ITEM');
          this.itemEditandoIndex = itemEditandoIndexSalvo ? JSON.parse(itemEditandoIndexSalvo) : null;
          const itemSalvo = novoItemSalvo ? JSON.parse(novoItemSalvo) : null;

          if (itemSalvo) {
            this.novoItem = {
              id: itemSalvo.id || null,
              imviditemmovimentacaoveiculo: itemSalvo.imviditemmovimentacaoveiculo || null,
              imvidnuvem: itemSalvo.imvidnuvem || null,
              tipo: (itemSalvo.tipo === 'M' || itemSalvo.tipo === 'M.O.') ? 'M' : 'P',
              produto: itemSalvo.produto || null,
              quantidade: itemSalvo.quantidade || 1,
              unidade: itemSalvo.unidade || 'UN',
              valorUnitario: itemSalvo.valorUnitario != null ? itemSalvo.valorUnitario : '',
              observacao: itemSalvo.observacao || '',
            };
          }
          this.dialogItem = true;
          sessionStorage.removeItem('MANUTENCAO_NOVO_ITEM');
          sessionStorage.removeItem('MANUTENCAO_ITEM_EDITANDO_INDEX');
          sessionStorage.removeItem('MANUTENCAO_DIALOG_ITEM_ABERTO');
        }

        sessionStorage.removeItem(MANUTENCAO_STORAGE.campoSelecao);
        sessionStorage.setItem(MANUTENCAO_STORAGE.formulario, JSON.stringify(this.formulario));
      } catch (e) {
        console.warn('Erro ao recuperar formulário da manutenção:', e);
      }
    },

    $_limparStorageManutencao() {
      sessionStorage.removeItem(MANUTENCAO_STORAGE.formulario);
      sessionStorage.removeItem(MANUTENCAO_STORAGE.campoSelecao);
      sessionStorage.removeItem(MANUTENCAO_STORAGE.itemSelecionado);
      sessionStorage.removeItem('MANUTENCAO_NOVO_ITEM');
      sessionStorage.removeItem('MANUTENCAO_ITEM_EDITANDO_INDEX');
      sessionStorage.removeItem('MANUTENCAO_DIALOG_ITEM_ABERTO');
      sessionStorage.removeItem('MANUTENCAO_SNAPSHOT');
      sessionStorage.removeItem('MANUTENCAO_SNAPSHOT_GARANTIA');
      sessionStorage.removeItem('MANUTENCAO_GARANTIA_DIGITADA');
      this.garantiaDigitada = '';
    },

    $_atualizarSnapshot() {
      this.$_sincronizarGarantiaDigitada();
      this.snapshotFormulario = JSON.stringify(this.formulario);
      sessionStorage.setItem('MANUTENCAO_SNAPSHOT', this.snapshotFormulario);
      sessionStorage.setItem('MANUTENCAO_SNAPSHOT_GARANTIA', this.garantiaDigitada || '');
      sessionStorage.setItem('MANUTENCAO_GARANTIA_DIGITADA', this.garantiaDigitada || '');
    },
  },

  created() {
    sessionStorage.setItem(ROTA_STORAGE.cadastro, 'manutencao');
    this.$_recuperarFormulario();
    if (this.formulario.garantia) {
      this.garantiaDigitada = this.$_formataDataExibicao(this.formulario.garantia);
    }
    this.$_findDb();
  },
};
</script>

<style scoped>
.center {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 16px 12px 32px 12px;
}

.linha {
  width: 100%;
}

.odometro-wrapper {
  display: flex;
  align-items: flex-start;
}

.campo-odometro {
  flex: 1;
}

.divisor-tela-toda {
  position: relative !important;
  left: 50% !important;
  right: 50% !important;
  width: 100vw !important;
  max-width: 100vw !important;
  margin-left: -50vw !important;
  margin-right: -50vw !important;
}

.odometro-wrapper >>> .v-input.mb-5 {
  margin-bottom: 0 !important;
}

.toggle-odometro {
  border-radius: 4px;
  flex-shrink: 0;
  display: flex;
}

.toggle-odometro-bloqueado {
  cursor: not-allowed;
}

.toggle-odometro-bloqueado >>> .v-btn.btn-toggle-item {
  pointer-events: none;
}

.toggle-odometro-bloqueado >>> .v-btn.v-btn--disabled {
  opacity: 0.5;
}

.toggle-odometro-bloqueado >>> .v-btn.v-btn--disabled.v-btn--active,
.toggle-odometro-bloqueado >>> .v-btn.v-btn--disabled.v-item--active {
  opacity: 1 !important;
  color: #4CAF50 !important;
  background-color: rgba(76, 175, 80, 0.12) !important;
  font-weight: bold !important;
}

.executor-wrapper {
  display: flex;
  align-items: flex-start;
}

.campo-executor {
  flex: 1;
  min-width: 0;
}

.executor-wrapper >>> .v-input.mb-5 {
  margin-bottom: 0 !important;
}

.toggle-tipo-manutencao {
  border-radius: 4px;
  flex-shrink: 0;
  display: flex;
}

.btn-toggle-manutencao {
  font-weight: 600;
  padding: 0 12px !important;
  text-transform: none;
  font-size: 0.9rem;
}

.btn-toggle-item {
  font-weight: bold;
  padding: 0 14px !important;
}

.divinferior {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
  margin-bottom: 16px;
  width: 100%;
}

.botaoinferior {
  color: white !important;
  font-weight: bold;
  flex: 1;
}

.botaocancelar {
  background-color: #757575 !important;
}

.botaosalvar {
  background-color: #4caf50 !important;
}

.botao-add-item {
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.3px;
  border-radius: 8px;
}

.itens-simplebar-scroll {
  max-height: 280px;
  padding: 2px 6px 0 2px;
}

.itens-simplebar-scroll ::v-deep .simplebar-scrollbar::before {
  background-color: #9e9e9e;
  border-radius: 4px;
  opacity: 0.6;
}

.itens-simplebar-scroll ::v-deep .simplebar-track.simplebar-vertical {
  width: 7px;
}

.item-card {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 8px 12px;
  transition: all 0.2s ease;
  width: 100%;
  box-sizing: border-box;
}

.item-card:hover {
  border-color: #81c784;
}

.item-card-inner {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  gap: 8px;
}

.item-info-col {
  display: flex;
  align-items: flex-start;
  flex: 1 1 auto;
  min-width: 0;
  gap: 8px;
}

.cursor-pointer {
  cursor: pointer;
}

.item-numero {
  font-size: 12px;
  background-color: #e8f5e9;
  padding: 2px 6px;
  border-radius: 4px;
  flex-shrink: 0;
  margin-top: 2px;
}

.item-textos {
  flex: 1 1 auto;
  min-width: 0;
}

.item-descricao {
  font-size: 13px;
  color: #2c3e50;
  display: block;
  word-break: break-word;
  overflow-wrap: break-word;
  line-height: 1.4;
}

.item-detalhe {
  font-size: 11px;
  margin-top: 2px;
  word-break: break-word;
}

.item-observacao {
  font-size: 11px;
  word-break: break-word;
  white-space: pre-wrap;
  line-height: 1.3;
}

.item-acoes {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.total-itens-linha {
  background-color: #ffffff;
  border-radius: 6px;
}

.card-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #2c3e50;
}

.toggle-tipo-item {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
}

.btn-toggle-tipo {
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 0.85rem !important;
  letter-spacing: 0.2px;
}

.toggle-tipo-item .v-btn.v-btn--active {
  background-color: #2e7d32 !important;
  color: #ffffff !important;
}

.toggle-tipo-item .v-btn.v-btn--active .v-icon {
  color: #ffffff !important;
}

.flex-dialog-actions {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.icon-dialog-salvar {
  position: absolute;
  right: 5%;
  color: black;
}
</style>
